/* tslint:disable:no-backbone-get-set-outside-model */

import 'gis';
import * as kendo from 'kendo/kendo.core';
import * as publisher from 'publisher';
import * as on from 'dojo/on';
import * as url from 'CMS/core/url';
import * as page from 'CMS/core/page';
import * as app from 'CMS/core/application';
import * as MapHelpers from 'visuris/Gis/MapHelpers';
import Locator from 'visuris/Gis/Locator';
import { ICalculateRouteOptions } from 'visuris/Gis/RouteCalculator';
import RouteCalculatorV2 from 'visuris/Gis/RouteCalculatorV2';
import RISIndexRepository from 'visuris/Data/Repositories/RISIndexRepository';
import BerthReservationRepository from 'visuris/Data/Repositories/BerthReservationRepository';
import RouteDirectionViewModel from 'visuris/ViewModels/Route/RouteDirectionViewModel';
import RouteEventViewModel from 'visuris/ViewModels/Route/RouteEventViewModel';
import RouteViewModel from 'visuris/ViewModels/Route/RouteViewModel';
import { create as createSuggestDataSource } from 'visuris/Data/Datasources/RISIndexSuggestDatasource';
import Hull from 'visuris/Data/Entities/Hull';
import WebpageRepository from 'CMS/Data/Repositories/WebpageRepository';
import HullRepository from 'visuris/Data/Repositories/HullRepository';
import ShipLinkRepository from 'visuris/Data/Repositories/ShipLinkRepository';
import ShipClaimRepository from 'visuris/Data/Repositories/ShipClaimRepository';
import GridSelectionDialog from 'visuris/Dialogs/GridSelectionDialog';
import ShipTypeByCEMTSelectionDialog from 'visuris/Dialogs/Custom/ShipTypeByCEMTSelectionDialog';
import { formatDate, formatLengthAsMeter, formatLengthAsMeterWithUnitAndDecimals } from 'visuris/Data/Formatters';
import { LengthUnit, LocationSearchRole } from 'visuris/Helpers/Enums';
import { alert, confirm } from 'CMS/UI/Popup';
import * as i18n from 'CMS/core/i18n';
import * as Constants from 'visuris/Constants';
import 'kendo/kendo.datetimepicker';
import 'kendo/kendo.sortable';
import 'kendo/kendo.autocomplete';
import 'kendo/kendo.tabstrip';
import 'jquery/delayed';
import RoutingResult from '../../Gis/RouteCalculatorDTOs/RoutingResult';
import RouteCalculatorRequest from '../../Gis/RouteCalculatorDTOs/RouteCalculatorRequest';
import Itinerary from '../../Gis/RouteCalculatorDTOs/Itinerary';
import Segment from '../../Gis/RouteCalculatorDTOs/Segment';
import Dimensions from '../../Gis/RouteCalculatorDTOs/Dimensions';
import Via from '../../Gis/RouteCalculatorDTOs/Via';
import RouteEvent from '../../Gis/RouteCalculatorDTOs/RouteEvent';
import ResultFormatting from '../../Gis/RouteCalculatorDTOs/ResultFormatting';
import FavoriteLocationsRepository from 'visuris/Data/Repositories/FavoriteLocationsRepository';
import RISIndex from 'visuris/Data/Entities/RISIndex';
import LocationData from '../../Data/Entities/FavoriteLocation';
import FavoriteVoyagesRepository from '../../Data/Repositories/FavoriteVoyagesRepository';
import FavoriteVoyage from '../../Data/Entities/FavoriteVoyage';
import SelectFavoriteVoyagePopup from '../../Popups/SelectFavoriteVoyagePopup';
import SelectVesselPopup from '../../Popups/SelectVesselPopup';
import FavoriteLocations from '../../Data/Entities/FavoriteLocations';
import CalculationOptions from '../../Gis/RouteCalculatorDTOs/CalculationOptions';
import { VoyageResultHelper } from '../../Helpers/VoyageResultHelper';
import * as RefData from 'AWFRefData/RefData';

class DirectionsViewModel {
    public stops: IDirectionsStopObservable[] = [];
    public dateTimeMode: 'arrive' | 'depart' = 'depart';
    public arriveDepartAt: Date = new Date();
    public avoidTide: boolean = false;
    public hull: Hull = null;
    public shipHeight: number = null;
    public shipLength: number = null;
    public shipDraught: number = null;
    public shipWidth: number = null;
    public shipSpeed: number = 15;
    public shipTonnage: number = null;
    public pleziervaart: boolean = false;
    public beroepsvaart: boolean = false;
    public passagiersvaart: boolean = false;
    public loaded: boolean = false;
    public adn: boolean = false;
    public convoy: boolean = false;
    public pusher: boolean = false;
    public outputLines: 'esriNAOutputLineNone' | 'esriNAOutputLineStraight' | 'esriNAOutputLineTrueShape' | 'esriNAOutputLineTrueShapeWithMeasure' = 'esriNAOutputLineTrueShape';
    public lengthUnits: 'esriNAUFeet' | 'esriNAUKilometers' | 'esriNAUMeters' | 'esriNAUMiles' | 'esriNAUNauticalMiles' | 'esriNAUYards' | 'esriNAUUnknown' = 'esriNAUMeters';
    public bestSequence: boolean = false;
    public fixedRoute: boolean = false;
    public usePassageDurations: boolean = false;
    public showUsePassageDurations: boolean = false;
    public shipOptionMessage: string = null;
    public arriveDepartAtMessage: string = null;
    public shipName: string = null;
    public shipIconElement: string = null;
    public useSailingSpeeds: boolean = false;
    public showUseSailingSpeeds: boolean = false;
    public useReducedDimensions: boolean = false;
    public useSmartReducedDimensions: boolean = false;
}

interface IDirectionsStop {
    isrs: string;
    address?: any;
    risIndex?: RISIndex;
    location?: {
        x: number, y: number, spatialReference: { wkid: number }
    };
    mapClickHandle: any;
}

interface IDirectionsStopObservable extends kendo.data.ObservableObject, IDirectionsStop { }

export default class Directions {
    private options: any;
    private $root: JQuery;
    private $directionTabs: JQuery;
    private $inputWrapper: JQuery;
    private $stopsContainer: JQuery;
    private $fastestRouteTabWrapper: JQuery;
    private $shortestRouteTabWrapper: JQuery;
    private mode: 'HOMEPAGE' | 'ROUTE' | 'VOYAGE';
    private map: any;
    private gisMap: any;
    private locator: Locator;
    private calculator2: RouteCalculatorV2;
    private routePointSelectorTemplate: (data: any) => string;
    private routeTextEntryTemplate: (data: any) => string;
    private routeSummaryTemplate: (data: any) => string;
    private routeResultHeaderTemplate: (data: any) => string;
    private suggestResultTemplate: string;
    private viewModel: DirectionsViewModel;
    private risIndexRepository: RISIndexRepository;
    private berthReservationRepository: BerthReservationRepository;
    private hullRepository: HullRepository;
    private shipLinkRepository: ShipLinkRepository;
    private shipClaimRepository: ShipClaimRepository;
    private favoriteLocationsRepository: FavoriteLocationsRepository;
    private favoriteVoyagesRepository: FavoriteVoyagesRepository;
    private webpageRepository: WebpageRepository;
    private currentRoute2: Itinerary[];

    private ignoreHashChange: boolean = false;
    private ignoreStopsChange: boolean = false;
    private isLoggedIn: boolean;

    private lockDetailUrl: string;
    private bridgeDetailUrl: string;
    private ntsDetailUrl: string;

    private reportingApplications: Map<string, any>;

    private static DefaultResolutionToRadiusMap = {
        38: 450,//1 op 2km
        76: 500,//1 op 4km
        152: 1200,//1 op 10km
        305: 2400,//1 op 20km
        611: 4500, //1 op 40km
        1222: 12000, //1 op 100km
        2445: 23000, //1 op 200km
        4891: 44000, //1 op 400km
    };

    private resolutionToRadiusMap: { [key: number]: number };

    private favoriteFunctionGroupName: string;
    private leaveNowMessage: string;

    private static MY_VESSELS: string = 'visuris.directions.myvessels';
    private static VESSEL_EXAMPLES: string = 'visuris.directions.vesselexamplesCEMT';
    private static FAVORITE_VOYAGES: string = 'visuris.directions.favoritevoyages';

    private showTravelledDistance: boolean = false;
    private travelledDistance: number;

    constructor() {
    }

    public initialize(options: any) {

        this.options = options;
        this.$root = $(options.root);
        if (options.params.showAddStop == true) {
            this.$root.find('.btn-add-stop').removeClass('hidden');
        }
        this.resolutionToRadiusMap = options.params.resolutionToRadiusMap || Directions.DefaultResolutionToRadiusMap;
        this.$directionTabs = this.$root.find('.directions-tabs');
        this.$inputWrapper = this.$root.find('.input-wrapper');
        this.$stopsContainer = this.$root.find('.stops-container');
        this.$fastestRouteTabWrapper = this.$root.find('.fastest-route-tab-wrapper');
        this.$shortestRouteTabWrapper = this.$root.find('.shortest-route-tab-wrapper');

        this.routePointSelectorTemplate = kendo.template(this.$root.find('#route-point-selector').html());
        this.routeTextEntryTemplate = kendo.template(this.$root.find('#template-route-text-entry').html());
        this.routeSummaryTemplate = kendo.template(this.$root.find('#template-route-summary').html());
        this.routeResultHeaderTemplate = kendo.template(this.$root.find('#template-route-result-header').html());

        this.suggestResultTemplate = this.$root.find('#template-suggest-result').html();
        this.risIndexRepository = new RISIndexRepository();
        this.berthReservationRepository = new BerthReservationRepository();
        this.hullRepository = new HullRepository();
        this.shipLinkRepository = new ShipLinkRepository();
        this.shipClaimRepository = new ShipClaimRepository();
        this.webpageRepository = new WebpageRepository();
        this.favoriteLocationsRepository = new FavoriteLocationsRepository();
        this.favoriteVoyagesRepository = new FavoriteVoyagesRepository();

        this.favoriteFunctionGroupName = i18n.getMessage('VisuRIS.Directions.FavoriteFunctionGroup');
        this.leaveNowMessage = i18n.getMessage('VisuRIS.Directions.LeaveNow');
        this.isLoggedIn = this.options.currentUser && this.options.currentUser.loggedIn;
        this.showTravelledDistance = this.options.params.showTravelledDistance;

        // Numeric text boxes
        this.buildNumericTextBox('length', { format: '0.##', restrictDecimals: true, step: 0.1, spinners: false });
        this.buildNumericTextBox('width', { format: '0.##', restrictDecimals: true, step: 0.1, spinners: false });
        this.buildNumericTextBox('draught', { format: '0.##', restrictDecimals: true, step: 0.1, spinners: false });
        this.buildNumericTextBox('height', { format: '0.##', restrictDecimals: true, step: 0.1, spinners: false });
        this.buildNumericTextBox('speed', { decimals: 0, restrictDecimals: true, format: 'n0', step: 1, spinners: false });
        this.buildNumericTextBox('tonnage', { decimals: 0, restrictDecimals: true, format: 'n0', step: 1, spinners: false });
        this.$root.find('.ship-length').tooltip({ title: i18n.getMessage('directions.lengthTip') });
        this.$root.find('.ship-width').tooltip({ title: i18n.getMessage('directions.widthTip') });
        this.$root.find('.ship-draught').tooltip({ title: i18n.getMessage('directions.draughtTip') });
        this.$root.find('.ship-height').tooltip({ title: i18n.getMessage('directions.heightTip') });
        this.$root.find('.ship-speed').tooltip({ title: i18n.getMessage('directions.speedTip') });
        this.$root.find('.ship-tonnage').tooltip({ title: i18n.getMessage('directions.tonnageTip') });

        //VList
        $.get(app.formatLocationUrl('{AWFVlist}/OData/Lists.svc/ReportingApplications?$format=json')).then((data) => {
            this.reportingApplications = new Map<string, any>();
            for (let i = 0; i < data.value.length; i++) {
                let wwauthorities = data.value[i].wwauthorities.split(';');
                for (let j = 0; j < wwauthorities.length; j++) {
                    if (this.reportingApplications.has(wwauthorities[j])) {
                        this.reportingApplications.set(wwauthorities[j], this.reportingApplications.get(wwauthorities[j]).push(data.value[i]));
                    } else {
                        this.reportingApplications.set(wwauthorities[j], [data.value[i]]);
                    }
                }
            }
        }, (error) => {
            console.error(error);
            alert(i18n.getMessage('Error getting reportingApplications'));
        });

        // Dialogs
        var currentUserID = app.getCurrentUser().id;
        var shipPicker: GridSelectionDialog = null;
        this.shipLinkRepository.getShipLinksForUser(currentUserID).then((shipLinks) => {
            if (shipLinks.length > 0) {
                shipPicker = new GridSelectionDialog({
                    content: this.$root.find('.ship-selection-dialog'),
                    title: i18n.getMessage('directions.selectShip'),
                    description: '',
                    gridType: 'visuris/Grids/Configs/UserShipLink',
                    filterType: 'UserShipLink',
                    relation: currentUserID
                });
                this.$root.find('.ship-selector').toggleClass('hidden', false);
            }
        }, (error) => {
            console.error(error);
        });
        var shipTypePicker = new ShipTypeByCEMTSelectionDialog({
            content: this.$root.find('.ship-type-selection-dialog'),
            title: i18n.getMessage('cemt.selectionHeader'),
            description: '',
            width: 500
        });

        let mapResolver: Promise<{ map: any, gisMap: any }>;
        if (options.params.map) {
            mapResolver = this.getMapFromPublisher();
        } else {
            mapResolver = Promise.resolve(null);
        }


        if (options.params.mode == null) {
            this.mode = 'VOYAGE';
        } else {
            this.mode = <'HOMEPAGE' | 'ROUTE' | 'VOYAGE'>(<string>options.params.mode).toUpperCase();
            this.toggleVoyageRouteMode();
        }

        mapResolver.then((value: any) => {
            if (value == null) { return; }
            var map = value.map;
            var gisMap = value.gisMap;

            // Create a new Locator
            Locator.create(this.options.params.locatorUrl).then((locator) => {

                //if (options.params.version == "v2") {
                this.calculator2 = RouteCalculatorV2.create(this.options.params.routeTaskUrl);
                //} else {
                //    this.calculator = RouteCalculator.create(this.options.params.routeTaskUrl);
                //}
                this.map = map;
                this.gisMap = gisMap;
                this.locator = locator;

                // Create ViewModel
                var vm = new DirectionsViewModel();
                vm.arriveDepartAt = new Date();

                // Set default values
                if (options.params.shipLength != null) {
                    vm.shipLength = Number(options.params.shipLength);
                }
                if (options.params.shipWidth != null) {
                    vm.shipWidth = Number(options.params.shipWidth);
                }
                if (options.params.shipDraught != null) {
                    vm.shipDraught = Number(options.params.shipDraught);
                }
                if (options.params.shipHeight != null) {
                    vm.shipHeight = Number(options.params.shipHeight);
                }
                if (options.params.shipSpeed != null) {
                    vm.shipSpeed = Number(options.params.shipSpeed);
                }
                if (options.params.shipTonnage != null) {
                    vm.shipTonnage = Number(options.params.shipTonnage);
                }
                if (options.params.adn != null) {
                    vm.adn = options.params.adn;
                }
                if (options.params.avoidTide != null) {
                    vm.avoidTide = options.params.avoidTide;
                }
                if (options.params.beroepsvaart != null) {
                    vm.beroepsvaart = options.params.beroepsvaart;
                }
                if (options.params.convoy != null) {
                    vm.convoy = options.params.convoy;
                }
                if (options.params.dateTimeMode != null) {
                    vm.dateTimeMode = options.params.dateTimeMode;
                }
                if (options.params.passagiersvaart != null) {
                    vm.passagiersvaart = options.params.passagiersvaart;
                }
                if (options.params.pleziervaart != null) {
                    vm.pleziervaart = options.params.pleziervaart;
                }
                if (options.params.pusher != null) {
                    vm.pusher = options.params.pusher;
                }
                if (options.params.showUsePassageDurations != null) {
                    vm.showUsePassageDurations = options.params.showUsePassageDurations;
                }

                if (options.params.showUseSailingSpeeds != null) {
                    vm.showUseSailingSpeeds = options.params.showUseSailingSpeeds;
                }

                vm.usePassageDurations = options.params.usePassageDurations ?? false;
                vm.useSailingSpeeds = options.params.useSailingSpeeds ?? false;
                vm.useReducedDimensions = options.params.useReducedDimensions ?? false;
                vm.useSmartReducedDimensions = options.params.useSmartReducedDimensions ?? false;
                vm.arriveDepartAtMessage = this.leaveNowMessage;

                this.viewModel = <DirectionsViewModel><any>kendo.observable(vm);

                // Add two stops to the view model
                this.addStop();
                this.addStop();

                // Input tab
                this.$directionTabs.kendoTabStrip({
                    select: e => {
                        if (e.item.classList.value.indexOf('fastest-route-tab-title-item') >= 0) {
                            this.showFastestRoute();
                            this.showShortestRoute(false);
                        } else if (e.item.classList.value.indexOf('shortest-route-tab-title-item') >= 0) {
                            this.showShortestRoute();
                            this.showFastestRoute(false);
                        }
                    }
                });
                this.$directionTabs.data('kendoTabStrip').select(0);
                this.$directionTabs.find('.fastest-route-tab-title-item').hide();
                this.$directionTabs.find('.shortest-route-tab-title-item').hide();
                i18n.bind(this.$root.find('.directions-tabs'));

                // vessel select
                const vesselSelectDatasource: any[] = [];
                if (this.isLoggedIn) {
                    vesselSelectDatasource.push({ name: i18n.getMessage(Directions.MY_VESSELS), value: Directions.MY_VESSELS });
                    vesselSelectDatasource.push({ name: i18n.getMessage(Directions.FAVORITE_VOYAGES), value: Directions.FAVORITE_VOYAGES });
                }
                vesselSelectDatasource.push({ name: i18n.getMessage(Directions.VESSEL_EXAMPLES), value: Directions.VESSEL_EXAMPLES });
                this.$root.find('.vessel-select').kendoDropDownList({
                    dataTextField: 'name',
                    dataValueField: 'value',
                    dataSource: vesselSelectDatasource,
                    autoBind: false,
                    text: i18n.getMessage('VisuRIS.Directions.VesselSelectChange'),
                    popup: {
                        appendTo: 'span.vessel-select'
                    },
                    cascade: e => {
                        // prevent the dropdown text to change to my vessels or vessel examples
                        if (vesselSelectDatasource.map(x => x.name).includes(e.sender.text())) {
                            e.sender.text(i18n.getMessage('VisuRIS.Directions.VesselSelectChange'));
                        }
                    },
                    select: (e) => {
                        e.preventDefault();
                        if (e.dataItem.value === Directions.MY_VESSELS) {
                            const vesselPopup = new SelectVesselPopup(selectedVessel => {
                                if (selectedVessel) {
                                    e.sender.text(selectedVessel.shipName);
                                    this.viewModel.shipName = selectedVessel.shipName;
                                    if (selectedVessel.hull) {
                                        this.viewModel.shipLength = selectedVessel.selectedVessel.hull.length ? selectedVessel.hull.length / 100 : null;
                                        this.viewModel.shipWidth = selectedVessel.hull.width ? selectedVessel.hull.width / 100 : null;
                                        this.viewModel.shipDraught = selectedVessel.hull.maximumDraught ? selectedVessel.hull.maximumDraught / 100 : null;
                                        this.viewModel.shipHeight = selectedVessel.hull.maximumHeight ? selectedVessel.hull.maximumHeight / 100 : null;
                                        this.viewModel.shipSpeed = selectedVessel.hull.maximumSpeed;
                                        if (selectedVessel.hull.grossRegisterTon) {
                                            this.viewModel.shipTonnage = selectedVessel.hull.grossRegisterTon;
                                        }
                                    } else if (selectedVessel.shipClaim) {
                                        this.viewModel.shipLength = selectedVessel.shipClaim.length;
                                        this.viewModel.shipWidth = selectedVessel.shipClaim.width;
                                        this.viewModel.shipDraught = selectedVessel.shipClaim.maximumDraught;
                                        this.viewModel.shipHeight = selectedVessel.shipClaim.maximumHeight;
                                        this.viewModel.shipSpeed = selectedVessel.shipClaim.speedOverGround;
                                        if (selectedVessel.shipClaim.grossRegisterTon) {
                                            this.viewModel.shipTonnage = selectedVessel.shipClaim.grossRegisterTon;
                                        }
                                        this.viewModel.beroepsvaart = selectedVessel.shipClaim.commercial;
                                        this.changeBeroepsvaartOption(this.viewModel.beroepsvaart);
                                        this.viewModel.passagiersvaart = selectedVessel.shipClaim.commercial && selectedVessel.shipClaim.passengersAllowed;
                                        this.viewModel.loaded = !this.viewModel.passagiersvaart; // unset default loaded status
                                        this.viewModel.shipOptionMessage = this.getShipOptionMessage();
                                        this.viewModel.shipIconElement = this.getShipIcon();
                                    }
                                    kendo.bind(this.$inputWrapper, this.viewModel);
                                }
                            });
                            vesselPopup.open();
                        }
                        else if (e.dataItem.value === Directions.VESSEL_EXAMPLES) {
                            // select vessel examples
                            shipTypePicker.show().then((selected) => {
                                if (selected != null) {
                                    const shipType = this.getCorrectShipType(selected);
                                    e.sender.text(shipType);
                                    this.viewModel.shipName = shipType;
                                    this.viewModel.hull = null;
                                    this.viewModel.shipLength = selected.maxlen ? Number(selected.maxlen.replace(',', '.')) : null;
                                    this.viewModel.shipWidth = selected.maxwidth ? Number(selected.maxwidth.replace(',', '.')) : null;
                                    this.viewModel.shipDraught = selected.maxdraught ? Number(selected.maxdraught.replace(',', '.')) : null;
                                    this.viewModel.shipHeight = selected.maxheight ? Number(selected.maxheight.replace(',', '.')) : null;
                                    if (selected.maxton) {
                                        this.viewModel.shipTonnage = Number(selected.maxton);
                                    }
                                    this.viewModel.beroepsvaart = selected.commercial ? Number(selected.commercial) === 1 : false;
                                    this.changeBeroepsvaartOption(this.viewModel.beroepsvaart);
                                    this.viewModel.convoy = selected.convoy ? Number(selected.convoy) === 1 : false;
                                    this.viewModel.shipOptionMessage = this.getShipOptionMessage();
                                    this.viewModel.shipIconElement = this.getShipIcon();
                                    kendo.bind(this.$inputWrapper, this.viewModel);
                                }
                            }, (error) => {
                                console.error(error);
                            });
                        }
                        else if (e.dataItem.value === Directions.FAVORITE_VOYAGES) {
                            // select favorite voyages
                            const favoriteVoyagePopup = new SelectFavoriteVoyagePopup(selectedVoyage => {
                                if (selectedVoyage) {
                                    this.updateModelFromFavoriteVoyageDto(selectedVoyage).then(() => {
                                        kendo.bind(this.$inputWrapper, this.viewModel);
                                        this.redrawStops();
                                    });
                                }
                            });
                            favoriteVoyagePopup.open();
                        }
                    }
                });

                // Ship options toggle
                const $shipOptionsToggle = this.$root.find('.ship-options-toggle');
                const $shipOptionsCheckboxes = this.$root.find('.ship-options-checkboxes');
                const shipOptionWindow = $shipOptionsCheckboxes.kendoWindow({
                    actions: ['Close'],
                    draggable: false,
                    resizable: false,
                    visible: false,
                    title: false,
                    appendTo: 'div#ship-options-wrapper'
                }).data('kendoWindow');
                this.viewModel.shipOptionMessage = this.getShipOptionMessage();
                this.viewModel.shipIconElement = this.getShipIcon();
                $shipOptionsCheckboxes.find('.btn-close-window').on('click', _ => {
                    if (!shipOptionWindow.element.is(":hidden")) {
                        shipOptionWindow.close();
                    }
                });
                $shipOptionsToggle.on('click', _ => {
                    if (shipOptionWindow.element.is(":hidden")) {
                        shipOptionWindow.open();
                    } else {
                        shipOptionWindow.close();
                    }
                });

                // Advanced options toggle
                const $advancedOptionsToggle = this.$root.find('.advanced-options-toggle');
                const $advancedOptionsCheckboxes = this.$root.find('.advanced-options-checkboxes');
                const advancedOptionWindow = $advancedOptionsCheckboxes.kendoWindow({
                    actions: ['Close'],
                    draggable: false,
                    resizable: false,
                    visible: false,
                    title: false,
                    appendTo: 'div#advanced-options-wrapper'
                }).data('kendoWindow');
                $advancedOptionsCheckboxes.find('.btn-close-window').on('click', _ => {
                    if (!advancedOptionWindow.element.is(":hidden")) {
                        advancedOptionWindow.close();
                    }
                });
                $advancedOptionsToggle.on('click', _ => {
                    if (advancedOptionWindow.element.is(":hidden")) {
                        advancedOptionWindow.open();
                    } else {
                        advancedOptionWindow.close();
                    }
                });

                // Handle option checks for voyage
                $shipOptionsCheckboxes.find('#checkbox-pleasure').on('change', (e) => {
                    this.changeBeroepsvaartOption(!(e.currentTarget as any).checked);
                });
                $shipOptionsCheckboxes.find('#checkbox-commercial').on('change', (e) => {
                    this.changeBeroepsvaartOption((e.currentTarget as any).checked);
                });
                $shipOptionsCheckboxes.find('#checkbox-passengers').on('change', (e) => {
                    if ((e.currentTarget as any).checked) {
                        this.viewModel.loaded = false;
                        this.viewModel.adn = false;
                        this.viewModel.convoy = false;
                        this.viewModel.pusher = false;
                        this.viewModel.passagiersvaart = true;
                        this.viewModel.beroepsvaart = true;
                        this.viewModel.pleziervaart = false;
                    } else {
                        this.viewModel.passagiersvaart = false;
                    }
                    this.viewModel.shipOptionMessage = this.getShipOptionMessage();
                    this.viewModel.shipIconElement = this.getShipIcon();
                    kendo.bind(this.$inputWrapper, this.viewModel);
                });
                $shipOptionsCheckboxes.find('#checkbox-loaded').on('change', (e) => {
                    if ((e.currentTarget as any).checked) {
                        this.viewModel.loaded = true;
                        this.viewModel.passagiersvaart = false;
                        this.viewModel.pleziervaart = false;
                        this.viewModel.beroepsvaart = true;
                    } else {
                        this.viewModel.loaded = false;
                        this.viewModel.adn = false;
                    }
                    this.viewModel.shipOptionMessage = this.getShipOptionMessage();
                    this.viewModel.shipIconElement = this.getShipIcon();
                    kendo.bind(this.$inputWrapper, this.viewModel);
                });
                $shipOptionsCheckboxes.find('#checkbox-adn').on('change', (e) => {
                    if ((e.currentTarget as any).checked) {
                        this.viewModel.loaded = true;
                        this.viewModel.adn = true;
                        this.viewModel.passagiersvaart = false;
                        this.viewModel.pleziervaart = false;
                        this.viewModel.beroepsvaart = true;
                    } else {
                        this.viewModel.adn = false;
                    }
                    this.viewModel.shipOptionMessage = this.getShipOptionMessage();
                    this.viewModel.shipIconElement = this.getShipIcon();
                    kendo.bind(this.$inputWrapper, this.viewModel);
                });
                $shipOptionsCheckboxes.find('#checkbox-convoy').on('change', (e) => {
                    if ((e.currentTarget as any).checked) {
                        this.viewModel.convoy = true;
                        this.viewModel.pusher = true;
                        this.viewModel.passagiersvaart = false;
                        this.viewModel.pleziervaart = false;
                        this.viewModel.beroepsvaart = true;
                    } else {
                        this.viewModel.convoy = false;
                        this.viewModel.pusher = false;
                    }
                    this.viewModel.shipOptionMessage = this.getShipOptionMessage();
                    this.viewModel.shipIconElement = this.getShipIcon();
                    kendo.bind(this.$inputWrapper, this.viewModel);
                });
                $shipOptionsCheckboxes.find('#checkbox-pusher').on('change', (e) => {
                    if ((e.currentTarget as any).checked) {
                        this.viewModel.convoy = true;
                        this.viewModel.pusher = true;
                        this.viewModel.passagiersvaart = false;
                        this.viewModel.pleziervaart = false;
                        this.viewModel.beroepsvaart = true;
                    } else {
                        this.viewModel.convoy = false;
                        this.viewModel.pusher = false;
                    }
                    this.viewModel.shipOptionMessage = this.getShipOptionMessage();
                    this.viewModel.shipIconElement = this.getShipIcon();
                    kendo.bind(this.$inputWrapper, this.viewModel);
                });
                this.changeBeroepsvaartOption(this.viewModel.beroepsvaart);

                this.$root.find('.btn-add-stop').on('click', (e) => {
                    this.addStop();
                });


                if (this.mode === 'HOMEPAGE') {
                    this.$root.find('.btn-calculate-route').on('click', (e) => {
                        window.location.href = this.options.params.routeCalculatorUrl + '#calculate=1&' + this.getUrlEncodedStopsSettings() + '&' + this.getUrlEncodedMoreOptionsSettings();
                    });
                } else {
                    // Check hash values
                    if (this.getValueFromHash('moreOptions') === '1') {
                        this.updateMoreOptionsFromHash();
                        kendo.bind(this.$inputWrapper, this.viewModel);
                    }

                    this.updateStopsFromHash().then(() => {
                        this.redrawStops();
                        if (this.getValueFromHash('calculate') === '1') {
                            this.onCalculateRouteClicked();
                        }
                    });

                    this.$root.find('.btn-calculate-route').on('click', (e) => {
                        this.onCalculateRouteClicked();
                    });
                }

                // Exchange button
                this.$root.find('.btn-exchange').on('click', (e) => {
                    if (this.viewModel.stops.length > 1) {
                        var lastStop = this.viewModel.stops[this.viewModel.stops.length - 1];
                        this.moveStop(lastStop, 0); // Move last stop to first
                    }
                });

                // Datetime picker
                // default limit for voyages starting in the past
                if (options.params.maxDaysInPast == null) {
                    options.params.maxDaysInPast = 10;
                }
                if (options.params.maxDaysInFuture == null) {
                    options.params.maxDaysInFuture = 365;
                }
                // limit how far user can go back or forward in time for startTime voyage
                let minDate = new Date();
                let maxDate = new Date();
                // setDate takes care of month changes as well!
                minDate.setDate(minDate.getDate() - options.params.maxDaysInPast);
                maxDate.setDate(maxDate.getDate() + options.params.maxDaysInFuture);
                const $datetimepicker = this.$root.find('.arrival-depart-datetime');
                $datetimepicker.kendoDateTimePicker({
                    min: minDate,
                    max: maxDate,
                    value: this.viewModel.arriveDepartAt,
                    format: 'dd/MM/yyyy HH:mm',
                    change: (e) => {
                        this.viewModel.arriveDepartAtMessage = formatDate(e.sender.value());
                        kendo.bind(this.$inputWrapper, this.viewModel);
                    }
                });
                // timepicker -> toggle to open window with datetimepicker
                const datetimepickerWindow = this.$root.find('.timepicker-control').kendoWindow({
                    actions: ['Close'],
                    draggable: false,
                    resizable: false,
                    visible: false,
                    title: false,
                    appendTo: 'div#timepicker-wrapper'
                }).data('kendoWindow');
                this.$root.find('.timepicker-control').find('.btn-close-window').on('click', _ => {
                    if (!datetimepickerWindow.element.is(":hidden")) {
                        datetimepickerWindow.close();
                    }
                });
                this.$inputWrapper.find('.timepicker-toggle').on('click', e => {
                    if (datetimepickerWindow.element.is(":hidden")) {
                        datetimepickerWindow.open();
                    } else {
                        datetimepickerWindow.close();
                    }
                });

                // Voyage route 
                const $voyageRouteSwitch = this.$root.find('.voyage-route-switch');
                ($voyageRouteSwitch as any).kendoSwitch({
                    checked: this.mode === 'ROUTE' ? false : true,
                    size: 'small',
                    messages: { checked: '', unchecked: '' },
                    change: (e: any) => {
                        if (e && e.checked) {
                            this.mode = 'VOYAGE';
                        } else {
                            this.mode = 'ROUTE';
                        }
                        this.toggleVoyageRouteMode();
                    }
                });

                // Save favorite voyage button
                const $saveFavoriteVoyageToggle = this.$root.find('.save-favorite-voyage-toggle');
                const $saveFavoriteVoyageWindow = this.$root.find('.save-favorite-voyage-window');
                const $favoriteVoyageNameInput = $saveFavoriteVoyageWindow.find('.textbox-favorite-voyage-name');
                const saveFavoriteVoyageWindow = $saveFavoriteVoyageWindow.kendoWindow({
                    actions: ['Close'],
                    draggable: false,
                    resizable: false,
                    visible: false,
                    title: false,
                    appendTo: 'div#save-favorite-voyage-wrapper'
                }).data('kendoWindow');
                $saveFavoriteVoyageWindow.find('.btn-save-favorite-voyage').on('click', async e => {
                    const favoriteName = $favoriteVoyageNameInput.val() as string;
                    const savedFavoriteVoyages = await this.favoriteVoyagesRepository.getFavoriteVoyagesByName(favoriteName);
                    if (savedFavoriteVoyages.length > 0) {
                        // overwrite confirm -> update favorite
                        confirm(i18n.getMessage('VisuRIS.Directions.OverwriteFavoriteVoyage')).then(() => {
                            const favoriteVoyage = this.getFavoriteVoyageDto(favoriteName, savedFavoriteVoyages[0].id);
                            this.favoriteVoyagesRepository.updateFavoriteVoyage(favoriteVoyage).then(() => {
                                saveFavoriteVoyageWindow.close();
                            }).catch(e => {
                                if (e.responseJson && e.responseJSON.exceptionMessage) {
                                    alert(i18n.getMessage('general.ApiError', e.responseJSON.exceptionMessage));
                                } else {
                                    alert(i18n.getMessage('dialog.serviceUnavailable'));
                                }
                            });
                        });
                    } else {
                        // save new favorite
                        const favoriteVoyage = this.getFavoriteVoyageDto(favoriteName);
                        this.favoriteVoyagesRepository.saveFavoriteVoyage(favoriteVoyage).then(e => {
                            saveFavoriteVoyageWindow.close();
                        }).catch(e => {
                            if (e.responseJSON.exceptionMessage) {
                                alert(i18n.getMessage('general.ApiError', e.responseJSON.exceptionMessage));
                            } else if (e.responseJSON.message) {
                                alert(e.responseJSON.message);
                            } else {
                                alert(i18n.getMessage('dialog.serviceUnavailable'));
                            }
                        })
                    }
                });
                $saveFavoriteVoyageToggle.on('click', _ => {
                    if (saveFavoriteVoyageWindow.element.is(':hidden')) {
                        const voyageName = this.getFavoriteVoyageName();
                        $favoriteVoyageNameInput.val(voyageName);
                        saveFavoriteVoyageWindow.open();
                    } else {
                        saveFavoriteVoyageWindow.close();
                    }
                });
                saveFavoriteVoyageWindow.element.find('.btn-close-window').on('click', _ => {
                    if (!saveFavoriteVoyageWindow.element.is(":hidden")) {
                        saveFavoriteVoyageWindow.close();
                    }
                });
                $saveFavoriteVoyageToggle.hide(); // show after the voyage has been calculated

                // Bind view model (MVVM) to input wrapper
                kendo.bind(this.$inputWrapper, this.viewModel);

                // Show widget
                this.$root.find('.directions-container').css('visibility', 'visible');

                // Create layers in correct order
                MapHelpers.getOrCreateLayer(map, 'passiveRouteLayer');
                MapHelpers.getOrCreateLayer(map, 'routeLayer');
                MapHelpers.getOrCreateLayer(map, 'segmentLayer');

                // Bind stops change event
                (<any>this.viewModel.stops).bind('change', (e: any) => {
                    this.updateHash();
                });

                // Add click event listener to close popups when clicked outside of popup
                const $advancedOptionsWrapper = this.$root.find('#advanced-options-wrapper');
                const $timepickerWrapper = this.$root.find('#timepicker-wrapper');
                const $shipOptionsWrapper = this.$root.find('#ship-options-wrapper');
                const $saveFavoriteVoyageWrapper = this.$root.find('#save-favorite-voyage-wrapper');
                document.addEventListener('click', (evt) => {
                    if (!$.contains($advancedOptionsWrapper.get(0), evt.target as any) && !advancedOptionWindow.element.is(":hidden")) {
                        advancedOptionWindow.close();
                    }
                    if (!$.contains($timepickerWrapper.get(0), evt.target as any) && !datetimepickerWindow.element.is(":hidden")) {
                        datetimepickerWindow.close();
                    }
                    if (!$.contains($shipOptionsWrapper.get(0), evt.target as any) && !shipOptionWindow.element.is(":hidden")) {
                        shipOptionWindow.close();
                    }
                    if (!$.contains($saveFavoriteVoyageWrapper.get(0), evt.target as any) && !saveFavoriteVoyageWindow.element.is(":hidden")) {
                        saveFavoriteVoyageWindow.close();
                    }
                });
            });

        });

        this.loadDetailUrls();
    }

    private toggleVoyageRouteMode() {
        if (this.mode === 'ROUTE') {
            this.$root.find('div#timepicker-wrapper').hide();
            this.$root.find('.btn-calculate-route').text(i18n.getMessage('VisuRIS.Directions.CalculateRouteButton'));
            this.$root.find('.a-icon-speed').add('.ship-speed').hide();
            this.$root.find('.ship-dimension-third-row').hide();
        } else {
            this.$root.find('div#timepicker-wrapper').show();
            this.$root.find('.btn-calculate-route').text(i18n.getMessage('VisuRIS.Directions.CalculateVoyageButton'));
            this.$root.find('.a-icon-speed').add('.ship-speed').show();
            this.$root.find('.ship-dimension-third-row').show();
        }
    }

    private changeBeroepsvaartOption(commercial: boolean) {
        if (commercial) {
            this.viewModel.pleziervaart = false;
            this.viewModel.beroepsvaart = true;
            this.viewModel.loaded = true;
            this.viewModel.adn = false;
            this.viewModel.convoy = false;
            this.viewModel.pusher = false;
            this.viewModel.passagiersvaart = false;
            this.viewModel.shipOptionMessage = this.getShipOptionMessage();
            this.viewModel.shipIconElement = this.getShipIcon();
            kendo.bind(this.$inputWrapper, this.viewModel);
        } else {
            this.viewModel.pleziervaart = true;
            this.viewModel.beroepsvaart = false;
            this.viewModel.loaded = false;
            this.viewModel.adn = false;
            this.viewModel.convoy = false;
            this.viewModel.pusher = false;
            this.viewModel.passagiersvaart = false;
            this.viewModel.shipOptionMessage = this.getShipOptionMessage();
            this.viewModel.shipIconElement = this.getShipIcon();
            kendo.bind(this.$inputWrapper, this.viewModel);
        }
    }

    private getShipOptionMessage(): string {
        this.$inputWrapper.find('.ship-options-toggle span').css('color', '#428bca');
        if (this.viewModel.pleziervaart) {
            return i18n.getMessage('VisuRIS.Directions.PleasureOption');
        } else {
            let message = i18n.getMessage('VisuRIS.Directions.ProfessionalOption');

            if (this.viewModel.passagiersvaart) {
                message += ' - ' + i18n.getMessage('VisuRIS.Directions.PassengerOption');
            } else {
                if (this.viewModel.loaded) {
                    message += ' - ' + i18n.getMessage('VisuRIS.Directions.LoadedOption');
                    if (this.viewModel.adn) {
                        this.$inputWrapper.find('.ship-options-toggle span').css('color', 'red');
                        message += ' - ' + i18n.getMessage('VisuRIS.Directions.DangerousOption');
                    }
                }

                if (this.viewModel.pusher) {
                    message += ' - ' + i18n.getMessage('VisuRIS.Directions.ConvoyOption');
                } else if (this.viewModel.convoy) {
                    message += ' - ' + i18n.getMessage('VisuRIS.Directions.PushOption');
                }
            }
            return message;
        }
    }

    private getShipIcon() {
        if (this.viewModel.passagiersvaart) {
            return '<span class="a-icon a-icon-ship-passenger"></span>';
        }
        if (this.viewModel.convoy) {
            return '<span class="a-icon a-icon-convoy"></span>';
        }
        if (this.viewModel.pleziervaart) {
            return '<span class="a-icon a-icon-ship-recreational"></span>';
        }
        return '<span class="a-icon a-icon-ship-inland"></span>';
    }

    /**
     * Handles HTTP error, not calculation error
     * @param reason
     */
    private calculateFailed(reason: any) {
        console.warn('Calculate failed ', reason);
        if (this.mode === 'ROUTE') {
            alert(i18n.getMessage('VisuRIS.Directions.RouteCalculationFailedMessage'), i18n.getMessage('VisuRIS.Directions.RouteCalculationFailedTitle'));
        } else {
            alert(i18n.getMessage('VisuRIS.Directions.VoyageCalculationFailedMessage'), i18n.getMessage('VisuRIS.Directions.VoyageCalculationFailedTitle'));
        }

    }

    private onCalculateRouteClicked() {
        // Check if viewmodel is valid
        if (this.viewModel == null || this.viewModel.stops == null || this.viewModel.stops.length < 2) { return; }

        // Check if all stops have an isrs
        for (let i = 0; i < this.viewModel.stops.length; i++) {
            if (this.viewModel.stops[i].isrs == null || this.viewModel.stops[i].isrs === '') {
                return;
            }
        }

        this.clearCurrentRoute();
        kendo.ui.progress(this.$root, true);
        this.$root.find('.k-loading-text').css('line-height', this.$root.find('.k-loading-mask').height() + 'px');
        this.calculateRouteV2().then(() => {
            kendo.ui.progress(this.$root, false);
        }, (reason) => {
            this.calculateFailed(reason);
            kendo.ui.progress(this.$root, false);
        });
    }

    private loadDetailUrls() {
        var webpageRepository = new WebpageRepository();
        webpageRepository.getWebpageURL(Constants.PageReferences.BRIDGE_DETAIL).then((webPageUrl) => {
            this.bridgeDetailUrl = webPageUrl;
        });
        webpageRepository.getWebpageURL(Constants.PageReferences.LOCK_DETAIL).then((webPageUrl) => {
            this.lockDetailUrl = webPageUrl;
        });
        webpageRepository.getWebpageURL(Constants.PageReferences.NTS_DETAIL_PAGE).then((webPageUrl) => {
            this.ntsDetailUrl = webPageUrl;
        });
    }

    private getMapFromPublisher(): Promise<{ map: any, gisMap: any }> {
        return new Promise((resolve, reject) => {
            publisher.subscribe("G_D_getMapResult", (result) => {
                resolve({ map: result.map, gisMap: result.gisMap });
            });
            publisher.publish("G_GM_getMap", { callbackStr: "G_D_getMapResult" });
            publisher.subscribe("G_GM_mapIsReady", (result) => {
                resolve({ map: result.map, gisMap: result.gisMap });
            });
        });
    }

    private showShortestRoute(isActiveRoute: boolean = true) {
        // Draw on map
        if (this.currentRoute2) {
            const route = this.currentRoute2.find(x => x.computationType === 'SHORTEST');
            if (route) {
                this.drawRouteOnMap([{
                    geometry: route.geometry,
                    attributes: {
                        length: route.totalLength,
                        name: "route"
                    }
                }], isActiveRoute);
            }
        } else {
            this.drawRouteOnMap(null, isActiveRoute);
        }
    }

    private showFastestRoute(isActiveRoute: boolean = true) {
        // Draw on map
        if (this.currentRoute2) {
            const route = this.currentRoute2.find(x => x.computationType === 'FASTEST');
            if (route) {
                this.drawRouteOnMap([{
                    geometry: route.geometry,
                    attributes: {
                        length: route.totalLength,
                        name: "route"
                    }
                }], isActiveRoute);
            }
        } else {
            this.drawRouteOnMap(null, isActiveRoute);
        }
    }

    private async setCurrentRouteV2(route: Itinerary[]) {
        this.currentRoute2 = route;
        for (let i = 0; i < route.length; i++) {
            const paths = await MapHelpers.fromGoogleCompressedPaths(route[i].geometry.paths);
            this.currentRoute2[i].geometry.paths = paths;
        }
        this.drawCurrentRoute();
    }

    private clearCurrentRoute() {
        this.currentRoute2 = null;
        this.drawCurrentRoute();
    }

    private drawCurrentRoute() {
        // Map viewmodels
        let viewmodelFastest: RouteViewModel = null;
        let viewmodelShortest: RouteViewModel = null;
        const directionTabs = this.$directionTabs.data('kendoTabStrip');

        if (this.currentRoute2 && this.currentRoute2.length >= 1) {
            const vm1 = this.toViewModels2(this.currentRoute2[0]);
            let vm2: RouteViewModel = null;
            if (this.currentRoute2.length === 2) {
                vm2 = this.toViewModels2(this.currentRoute2[1]);
            }
            if (this.currentRoute2[0].computationType === 'FASTEST') {
                viewmodelFastest = vm1;
                viewmodelShortest = vm2;
            } else {
                viewmodelShortest = vm1;
                viewmodelFastest = vm2;
            }
        } else {
            // Hide all route information
            this.drawRouteOnMap(null);
            this.drawRouteOnMap(null, false);
            this.$directionTabs.find('.fastest-route-tab-title').text('');
            this.$directionTabs.find('.shortest-route-tab-title').text('');
            this.$fastestRouteTabWrapper.empty();
            this.$shortestRouteTabWrapper.empty();
            this.$directionTabs.find('.fastest-route-tab-title-item').hide();
            this.$directionTabs.find('.shortest-route-tab-title-item').hide();
            this.$root.find('.save-favorite-voyage-toggle').hide();
            return;
        }
        if (this.isLoggedIn && (viewmodelFastest != null || viewmodelShortest != null)) {
            // Show save voyage as favorite button if logged in
            this.$root.find('.save-favorite-voyage-toggle').show();
        }
        // draw routes' text
        const fastestEqualsShortestRoute = JSON.stringify(viewmodelFastest) === JSON.stringify(viewmodelShortest);
        if (viewmodelFastest != null) {
            viewmodelFastest.hasSameShortestRoute = fastestEqualsShortestRoute;
            this.drawRouteText(viewmodelFastest, this.$fastestRouteTabWrapper);
            const tabTitle = viewmodelFastest.formattedTotalLength() + ' - ' + viewmodelFastest.formattedTotalTime();
            this.$directionTabs.find('.fastest-route-tab-title').text(tabTitle);
            this.$directionTabs.find('.fastest-route-tab-title-item').show();
        }
        // no need to draw shortest route when it is same as fastest
        if (viewmodelShortest != null && !fastestEqualsShortestRoute) {
            this.drawRouteText(viewmodelShortest, this.$shortestRouteTabWrapper);
            const tabTitle = viewmodelShortest.formattedTotalLength() + ' - ' + viewmodelShortest.formattedTotalTime();
            this.$directionTabs.find('.shortest-route-tab-title').text(tabTitle);
            this.$directionTabs.find('.shortest-route-tab-title-item').show();
        }
        // show route (first fastest then shortest)
        if ((viewmodelFastest != null && viewmodelShortest == null) || fastestEqualsShortestRoute) {
            directionTabs.select(1);
            this.$directionTabs.find('.shortest-route-tab-title-item').hide();
        } else if (viewmodelShortest != null && viewmodelFastest == null) {
            directionTabs.select(2);
            this.$directionTabs.find('.fastest-route-tab-title-item').hide();
        } else {
            // both routes -> show fastest in color and shortest gray
            directionTabs.select(1);
        }
    }

    private drawAuthoritiesButtons(viewmodel: RouteViewModel, $container: JQuery) {
        let buttonData: any[] = [];
        for (let i = 0; i < viewmodel.authorities.length; i++) {
            if (this.reportingApplications.has(viewmodel.authorities[i])) {
                buttonData = buttonData.concat(this.reportingApplications.get(viewmodel.authorities[i]))
            }
        }
        buttonData = this.arrayUnique(buttonData);
        if (buttonData.length > 0) {
            //$container.append("<h5 class=\"color-a1 reporting-apps-header\">" + i18n.getMessage("VisuRIS.Directions.reportingApplicationsHeader") + "</h5>");
            $container.append("<div class=\"reporting-apps-buttons-pane\" style=\"display:flex;flex-wrap: wrap;gap: 10px 10px;\"></div><br>");
            let $reportingApplicationsButtonsPane = $container.find(".reporting-apps-buttons-pane");

            for (let i = 0; i < buttonData.length; i++) {
                $reportingApplicationsButtonsPane.append("<button style=\"border-radius: 5px;\" type=\"button\" class=\"btn btn-primary btn-reporting-app-" + buttonData[i].id + "\">" + i18n.getMessage("VisuRIS.Directions.SubmitTo") + " " + buttonData[i].reportingapp + "</button>")
                $reportingApplicationsButtonsPane.on("click", ".btn-reporting-app-" + buttonData[i].id, (e) => {
                    e.preventDefault();
                    let data = buttonData[i];
                    let wwauthorities: string[] = data.wwauthorities.split(";");
                    let vm = viewmodel;

                    let matched = [];
                    let unmatched = [];

                    for (let i = 0; i < vm.authorities.length; i++) {
                        if (wwauthorities.includes(vm.authorities[i])) {
                            matched.push(vm.authorities[i]);
                        } else {
                            unmatched.push(vm.authorities[i]);
                        }
                    }

                    let routeParameters = this.getRouteTaskParameters();
                    let url = new URL(data.voyageurl);

                    Object.entries(routeParameters).forEach((entry: [string, any]) => {
                        if (entry[0] === 'departureTime' || entry[0] === 'endTime') {
                            url.searchParams.append(entry[0], entry[1].toJSON());
                        } else if (entry[0] === 'stops') { // CEERIS needs 'comma' separated instead of 'semicolon' separated
                            url.searchParams.append(entry[0], entry[1].replaceAll(';', ','));
                        } else {
                            url.searchParams.append(entry[0], entry[1]);

                        }
                    });

                    // Option to enable/disable unmatched popup when reporting a voyage to a reporting app
                    if (unmatched.length > 0 && this.options.params.showUnmatchedPopUpMessage == true) {
                        confirm(i18n.getMessage("VisuRIS.Directions.UnmatchedPopUpMessage", matched.join(", "), unmatched.join(", ")), i18n.getMessage("VisuRIS.Directions.UnmatchedPopUpTitle")).then(() => {
                            window.open(url.href, '_blank');
                        });
                    } else {
                        window.open(url.href, '_blank');
                    }
                });
            }
        }
    }

    private drawRouteText(viewmodel: RouteViewModel, $container: JQuery) {
        // Clear results
        $container.empty();

        // Route result header (only draw if tide dependant or nts impact or details or fastest=shortest)
        this.drawRouteResultHeader(viewmodel, $container);

        // Summary
        this.drawRouteResultSummary(viewmodel, $container);
        
        // dotted line
        const $hr = $('<hr style="border: none; border-top: 1px dotted black;"></hr>');
        $hr.appendTo($container);

        // Route
        viewmodel.directions.forEach((direction, dirIndex) => {
            const $featureDiv = $(this.routeTextEntryTemplate({ dir: direction, amountOfStops: this.viewModel.stops.length }));
            $featureDiv.hover(async (e) => {
                // Mouse in
                const geometry = $(e.currentTarget).data('geometry');
                const segment = await MapHelpers.fromGoogleCompressedGeometry(geometry);
                MapHelpers.highlightToSegmentOnMap(this.map, segment);
            }, (e) => {
                // Mouse out
                MapHelpers.unHighlightSegmentOnMap(this.map);
            });
            const $directionTitle = $featureDiv.find('.vcenter');
            // Toggle events
            if (direction.events && direction.events.length > 0) {
                const $featureEventsToggleBtn = $featureDiv.find('.toggle-directions-event-btn');
                $directionTitle.add($featureEventsToggleBtn).on('click', async e => {
                    const $featureEvents = $featureDiv.find('.directions-events');
                    if ($featureEventsToggleBtn.hasClass('vi-rotate-180')) {
                        // hide details
                        $featureEvents.hide();
                        $featureEventsToggleBtn.removeClass('vi-rotate-180');
                        if (!direction.isCommonBorder()) {
                            $featureDiv.css('border-color', 'lightgray');
                        }
                        // unhighlight segment when hidding
                        MapHelpers.unHighlightSegmentOnMap(this.map);
                    } else {
                        // show details
                        $featureEvents.show();
                        $featureEventsToggleBtn.addClass('vi-rotate-180');
                        if (!direction.isCommonBorder()) {
                            $featureDiv.css('border-color', 'gray');
                        }
                        // zoom to segment when showing
                        const geometry = $featureDiv.data('geometry');
                        const segment = await MapHelpers.fromGoogleCompressedGeometry(geometry);
                        MapHelpers.highlightToSegmentOnMap(this.map, segment, 'segmentLayer', true);
                    }
                });
            } else {
                // Zoom to segment on title click for items without events
                $directionTitle.on('click', async e => {
                    const geometry = $featureDiv.data('geometry');
                    const segment = await MapHelpers.fromGoogleCompressedGeometry(geometry);
                    MapHelpers.highlightToSegmentOnMap(this.map, segment, 'segmentLayer', true);
                });
            }
            $featureDiv.appendTo($container);
        });

        $('<br/>').appendTo($container);

        // Report button
        this.drawAuthoritiesButtons(viewmodel, $container);

        // Add make berth reservation button
        const lastStop = viewmodel.directions[viewmodel.directions.length - 1];
        if (lastStop.isrs) {
            this.berthReservationRepository.isBerthReservableByUser(lastStop.isrs).then((reservable) => {
                if (reservable) {
                    //this.$makeReservationButton.toggleClass('hidden', false);
                    const $makeBerthReservation = $('<button style="border-radius: 5px;" type="button" class="btn btn-primary btn-make-berth-reservation"></button>');
                    $makeBerthReservation.on('click', e => {
                        const $getURL = this.webpageRepository.getWebpageURL(Constants.PageReferences.BERTH_RESERVATION_PAGE);
                        $getURL.then((currentUrl) => {
                            currentUrl = url.updateUrlParameter(currentUrl, 'isrs', lastStop.isrs);
                            currentUrl = url.updateUrlParameter(currentUrl, 'startTime', lastStop.eta.getTime().toString());
                            window.open(currentUrl, '_blank');
                        }, (error) => {
                            console.error(error);
                            alert(i18n.getMessage('dialog.serviceUnavailable'));
                        });
                    });
                    const $makeBerthReservationDiv = $('<div></div>');
                    $makeBerthReservation.appendTo($makeBerthReservationDiv);
                    $makeBerthReservationDiv.appendTo($container);
                } else {
                    console.warn('Destination (' + lastStop.isrs + ') is not a reservable berth');
                }
            });
        }
    }

    private drawRouteResultSummary(viewmodel: RouteViewModel, $container: JQuery) {
        const $summary = $(this.routeSummaryTemplate(viewmodel));
        i18n.bind($summary);
        // Tooltip non allowed dimensions
        if (!viewmodel.isMaxTrajectDraughtSourceAllowedDim()) {
            const $tooltipSpan = $('<span></span>').addClass('vi vi-info route-summary-dimension-icon');
            $tooltipSpan.attr("data-toggle", "tooltip");
            const tooltipText = viewmodel.formattedMaxTrajectDraughtSource();
            $tooltipSpan.tooltip({ title: tooltipText.charAt(0).toUpperCase() + tooltipText.slice(1) });
            $tooltipSpan.appendTo($summary.find('.max-draught-label-wrapper'));
        }
        if (!viewmodel.isMaxTrajectHeightSourceAllowedDim()) {
            const $tooltipSpan = $('<span></span>').addClass('vi vi-info route-summary-dimension-icon');
            $tooltipSpan.attr("data-toggle", "tooltip");
            const tooltipText = viewmodel.formattedMaxTrajectHeightSource();
            $tooltipSpan.tooltip({ title: tooltipText.charAt(0).toUpperCase() + tooltipText.slice(1) });
            $tooltipSpan.appendTo($summary.find('.max-height-label-wrapper'));
        }
        if (!viewmodel.isMaxTrajectLengthSourceAllowedDim()) {
            const $tooltipSpan = $('<span></span>').addClass('vi vi-info route-summary-dimension-icon');
            $tooltipSpan.attr("data-toggle", "tooltip");
            const tooltipText = viewmodel.formattedMaxTrajectLengthSource();
            $tooltipSpan.tooltip({ title: tooltipText.charAt(0).toUpperCase() + tooltipText.slice(1) });
            $tooltipSpan.appendTo($summary.find('.max-length-label-wrapper'));
        }
        if (!viewmodel.isMaxTrajectWidthSourceAllowedDim()) {
            const $tooltipSpan = $('<span></span>').addClass('vi vi-info route-summary-dimension-icon');
            $tooltipSpan.attr("data-toggle", "tooltip");
            const tooltipText = viewmodel.formattedMaxTrajectWidthSource();
            $tooltipSpan.tooltip({ title: tooltipText.charAt(0).toUpperCase() + tooltipText.slice(1) });
            $tooltipSpan.appendTo($summary.find('.max-width-label-wrapper'));
        }
        $summary.appendTo($container);
    }

    private drawRouteResultHeader(viewmodel: RouteViewModel, $container: JQuery) {
        const hasEvents = viewmodel.directions.filter(dir => dir.events && dir.events.length > 0).length > 0;
        let ntsCount = 0;
        const countries = new Set();
        const watercharges = viewmodel.directions.filter(dir => dir.maneuverType === 'wwChargesStart').length > 0;
        for (const dir of viewmodel.directions) {
            if (dir.maneuverType === 'NtsImpactStart' || dir.maneuverType === 'NtsImpact') {
                ntsCount++;
            }
            if (dir.countryCodes != null && dir.countryCodes.length >= 1) {
                dir.countryCodes.forEach(x => countries.add(x));
            }
        }
        if (hasEvents || viewmodel.containsTideDep || ntsCount > 0 || viewmodel.hasSameShortestRoute || watercharges || countries.size >= 2) {
            const $routeHeader = $(this.routeResultHeaderTemplate(viewmodel));
            i18n.bind($routeHeader);
            if (hasEvents) {
                $routeHeader.find('.btn-show-details').on('click', e => {
                    e.preventDefault();
                    const $detailIcon = $container.find('.show-details-icon');
                    const $featureEvents = $container.find('.directions-events:has(.directions-event)');
                    const $featureDiv = $container.find('.directions-route-step.directions-route-step-border:has(div .directions-event)');
                    const $featureEventsToggleBtn = $container.find('.toggle-directions-event-btn');
                    if ($detailIcon.hasClass('vi-rotate-180')) {
                        // hide details
                        $detailIcon.removeClass('vi-rotate-180');
                        $featureEvents.hide();
                        $featureDiv.css('border-color', 'lightgray');
                        if ($featureEventsToggleBtn.hasClass('vi-rotate-180')) {
                            $featureEventsToggleBtn.removeClass('vi-rotate-180');
                        }
                    } else {
                        // show details
                        $detailIcon.addClass('vi-rotate-180');
                        $featureEvents.show();
                        $featureDiv.css('border-color', 'gray');
                        if (!$featureEventsToggleBtn.hasClass('vi-rotate-180')) {
                            $featureEventsToggleBtn.addClass('vi-rotate-180');
                        }
                    }
                });
            } else {
                $routeHeader.find('.btn-show-details').hide();
            }

            // Summary header message (tide, NtS, watercharges, bordercrossing)
            if (viewmodel.containsTideDep) {
                $routeHeader.find('.route-result-tidedep-message').text(i18n.getMessage('bridge.tidedependent'));
            } else {
                $routeHeader.find('.route-result-tidedep-message').hide();
                $routeHeader.find('.route-result-tidedep-icon').hide();
            }

            if (ntsCount > 0) {
                const ntsMessage = ntsCount + ' ' + i18n.getMessage('VisuRIS.Directions.Limitations');
                $routeHeader.find('.route-result-limitations-message').text(ntsMessage);
            } else {
                $routeHeader.find('.route-result-limitations-message').hide();
                $routeHeader.find('.route-result-limitations-icon').hide();
            }

            if (watercharges) {
                $routeHeader.find('.route-result-watercharges-message').text(i18n.getMessage('VisuRIS.Directions.RouteWaterwayCharges'));
            } else {
                $routeHeader.find('.route-result-watercharges-message').hide();
                $routeHeader.find('.route-result-watercharges-icon').hide();
            }

            if (countries.size >= 2) {
                $routeHeader.find('.route-result-bordercrossing-message').text(i18n.getMessage('VisuRIS.Directions.RouteCrossingBorder') + ' ');
                countries.forEach(async (x: string) => {
                    const countryCodeMessage = await RefData.getMessage('REF.CountryCode', x.toUpperCase());
                    const $cbFlag = $('<div></div>').addClass('a-icon-16px directions-route-result-flag-icon a-icon-country-' + x.toLowerCase());
                    $cbFlag.attr("data-toggle", "tooltip");
                    $cbFlag.tooltip({ title: countryCodeMessage });
                    $cbFlag.appendTo($routeHeader.find('.route-result-bordercrossing-message'));
                });
            } else {
                $routeHeader.find('.route-result-bordercrossing-message').hide();
                $routeHeader.find('.route-result-bordercrossing-icon').hide();
            }

            if (!viewmodel.hasSameShortestRoute) {
                $routeHeader.find('.route-result-info-icon').hide();
                $routeHeader.find('.route-result-info-message').hide();
            } else {
                $routeHeader.find('.route-result-info-message').text(i18n.getMessage('VisuRIS.Directions.FastestEqualsShortestRoute'));
            }

            $routeHeader.appendTo($container);
        }
    }

    private drawRouteOnMap(features: any, isActiveRoute: boolean = true) {
        MapHelpers.drawRouteOnMap(this.map, features, isActiveRoute ? 'routeLayer' : 'passiveRouteLayer', true, isActiveRoute);
    }

    private drawLocationMarkersOnMap() {
        MapHelpers.clearLayer(this.map, 'stopsLayer').then(() => {
            const stops = this.viewModel.stops;
            const firstMarkerPicture = app.formatLocationUrl('{gis}/images/greenPoint.png');
            const markerPicture = app.formatLocationUrl('{gis}/images/redPoint.png');
            for (let i = 0; i < stops.length; i++) {
                const stop = stops[i];
                const pictureUrl = (i === 0) ? firstMarkerPicture : markerPicture;
                if (stop.location) {
                    MapHelpers.drawLocationMarkerOnMap(this.map, stop.location, pictureUrl, String.fromCharCode(65 + i), 'stopsLayer');
                }
            }
        });
    }

    private getString(esriStrings: any, nameOfString: string): string {
        if (esriStrings != null && esriStrings.length) {
            for (let i = 0; i < esriStrings.length; i++) {
                if (esriStrings[i].stringType === nameOfString) {
                    return esriStrings[i].String;
                }
            }
        }
        return null;
    }

    private getStrings(esriStrings: any, nameOfString: string): string[] {
        let result = [];
        if (esriStrings != null && esriStrings.length) {
            for (let i = 0; i < esriStrings.length; i++) {
                if (esriStrings[i].stringType === nameOfString) {
                    result.push(esriStrings[i].String);
                }
            }
        }
        return result;
    }

    private addNtSInformationFromStrings(event: RouteEventViewModel, fnGetString: (name: string) => string): RouteEventViewModel {
        var headerId = fnGetString("NtSHeaderId");
        var sectionId = fnGetString("NtSSectionId");

        if (this.ntsDetailUrl != null && this.ntsDetailUrl !== "" && headerId != null && sectionId != null) {
            var urlToDetail = url.updateUrlParameter(this.ntsDetailUrl, 'headerid', headerId);
            urlToDetail = url.updateUrlParameter(urlToDetail, 'sectionid', sectionId);
            event.urlToDetail = urlToDetail;
        }

        return event;
    }

    private addNtsUrlToSegment(segment: RouteDirectionViewModel, fnGetString: (name: string) => string): RouteDirectionViewModel {
        const headerId = fnGetString("NtSHeaderId");
        const sectionId = fnGetString("NtSSectionId");

        if (this.ntsDetailUrl != null && this.ntsDetailUrl !== "" && headerId != null && sectionId != null) {
            let urlToDetail = url.updateUrlParameter(this.ntsDetailUrl, 'headerid', headerId);
            urlToDetail = url.updateUrlParameter(urlToDetail, 'sectionid', sectionId);
            segment.urlToDetail = urlToDetail;
        }

        return segment;
    }

    private addRadioChannelFromStrings(event: RouteEventViewModel, radioChannel: string, callSign: string): RouteEventViewModel {
        // Do not repeat VHF Channel if it is already in the rdocal title
        if (radioChannel && !event.title.includes(radioChannel)) {
            if (callSign) {
                radioChannel += " " + callSign;
            }
            event.secondaryInformation.push({ key: i18n.getMessage("facility.vhfChannel"), value: radioChannel, type: 'radioChannel' });
        }
        return event;
    }

    private getUrlFromStrings(facilityType: string, isrs: string): string {
        let baseUrl = facilityType == 'bridge' ? this.bridgeDetailUrl : this.lockDetailUrl;
        if (baseUrl && isrs) {

            var urlFromStrings = url.updateUrlParameter(baseUrl, 'facilityType', facilityType);
            urlFromStrings = url.updateUrlParameter(urlFromStrings, 'isrs', isrs);
            urlFromStrings = url.updateUrlParameter(urlFromStrings, 'id', isrs);
            return urlFromStrings;
        }
        return null;
    }

    private addBridgeInformationFromStrings(event: RouteEventViewModel, fnGetString: (name: string) => string): RouteEventViewModel {
        const operatable = fnGetString("Operatable");
        const airDraught = fnGetString("AirDraught");
        const airDraughtClosed = fnGetString("AirDraughtClosed");
        const airDraughtSource = fnGetString("AirDraughtSource");
        const airDraughtClosedSource = fnGetString("AirDraughtClosedSource");
        const noLimitationText = i18n.getMessage('VisuRIS.Directions.nolimitation');
        const noLimitationTranslation = noLimitationText.charAt(0).toUpperCase() + noLimitationText.slice(1);
        if (operatable === "1") {
            if (airDraught) {
                let translationKey = '';
                if (airDraughtSource === 'MAXIMUM_PREDICTED') {
                    translationKey = 'bridge.airdraughtOpenDynamicPredicted';
                } else if (airDraughtSource === 'MAXIMUM_ACTUAL') {
                    translationKey = 'bridge.airdraughtOpenDynamicActual';
                } else if (airDraughtSource === 'MAXIMUM_STATIC') {
                    translationKey = 'bridge.airdraughtOpen';
                } else if (airDraughtSource === 'NTS') {
                    translationKey = 'bridge.ntsImapctedHeightOpen';
                } else {
                    translationKey = 'bridge.allowedHeightOpen';
                }
                const airDraughtOpenValue = airDraught ? formatLengthAsMeterWithUnitAndDecimals(Number(airDraught), LengthUnit.Centimeter) : noLimitationTranslation;
                event.secondaryInformation.push({ key: i18n.getMessage(translationKey), value: airDraughtOpenValue });
            } else {
                event.secondaryInformation.push({ key: i18n.getMessage('bridge.allowedHeightOpen'), value: noLimitationTranslation });
            }
            if (airDraughtClosed) {
                let translationKey = '';
                if (airDraughtClosedSource === 'MAXIMUM_PREDICTED') {
                    translationKey = 'bridge.airdraughtClosedDynamicPredicted';
                } else if (airDraughtClosedSource === 'MAXIMUM_ACTUAL') {
                    translationKey = 'bridge.airdraughtClosedDynamicActual';
                } else if (airDraughtClosedSource === 'MAXIMUM_STATIC') {
                    translationKey = 'bridge.airdraughtClosed';
                } else if (airDraughtClosedSource === 'NTS') {
                    translationKey = 'bridge.ntsImapctedHeightClosed';
                } else {
                    translationKey = 'bridge.allowedHeightClosed';
                }
                const airDraughtClosedValue = airDraughtClosed ? formatLengthAsMeterWithUnitAndDecimals(Number(airDraughtClosed), LengthUnit.Centimeter) : i18n.getMessage('VisuRIS.Directions.nolimitation');
                event.secondaryInformation.push({ key: i18n.getMessage(translationKey), value: airDraughtClosedValue });
            } else {
                event.secondaryInformation.push({ key: i18n.getMessage('bridge.allowedHeightClosed'), value: noLimitationTranslation });
            }
        } else {
            let translationKey = '';
            if (airDraughtSource === 'MAXIMUM_PREDICTED') {
                translationKey = 'bridge.airdraughtDynamicPredicted';
            } else if (airDraughtSource === 'MAXIMUM_ACTUAL') {
                translationKey = 'bridge.airdraughtDynamicActual';
            } else if (airDraughtSource === 'MAXIMUM_STATIC') {
                translationKey = 'bridge.airdraught';
            } else if (airDraughtSource === 'NTS') {
                translationKey = 'bridge.ntsImapctedHeight';
            } else {
                translationKey = 'bridge.allowedHeight';
            }
            const airDraughtValue = airDraught ? formatLengthAsMeterWithUnitAndDecimals(Number(airDraught), LengthUnit.Centimeter) : noLimitationTranslation;
            event.secondaryInformation.push({ key: i18n.getMessage(translationKey), value: airDraughtValue });
        }

        const clearanceWidth = fnGetString('ClearanceWidth');
        const allowedWidth = fnGetString('AllowedWidth');
        if (clearanceWidth) {
            event.secondaryInformation.push({ key: i18n.getMessage('bridge.clearanceWidth'), value: formatLengthAsMeterWithUnitAndDecimals(Number(clearanceWidth), LengthUnit.Centimeter) });
        } else if (allowedWidth) {
            event.secondaryInformation.push({ key: i18n.getMessage('bridge.allowedWidth'), value: formatLengthAsMeterWithUnitAndDecimals(Number(allowedWidth), LengthUnit.Centimeter) });
        } else {
            event.secondaryInformation.push({ key: i18n.getMessage('bridge.allowedWidth'), value: noLimitationTranslation });
        }

        return event;
    }

    private toDirection(segment: Segment, index: number): RouteDirectionViewModel {
        var events: RouteEventViewModel[] = [];
        if (segment.events != null && segment.events.length) {
            segment.events.forEach((ev: RouteEvent) => {
                if (ev.eventProperties && ev.eventType && ev.eventType != 'Hidden') {
                    let event = new RouteEventViewModel();
                    event.title = VoyageResultHelper.getEventMessage(ev);
                    event.type = ev.eventType.toLowerCase();
                    if (ev.eta) {
                        event.eTA = new Date(ev.eta);
                    }
                    if (ev.etd && ev.etd.getTime() != ev.eta.getTime()) {
                        event.eTD = new Date(ev.etd);
                    }
                    var highlightString = ev.eventProperties["highLightLateArrival"];
                    if (highlightString != null && highlightString === "1") {
                        event.highlightArrivalTime = true;
                    }
                    event.secondaryInformation = [];
                    if (ev.eventType === "Bridge") {
                        event = this.addBridgeInformationFromStrings(event, (name: string) => ev.eventProperties[name]);
                        event.urlToDetail = this.getUrlFromStrings(event.type, ev.isrs);
                        event = this.addRadioChannelFromStrings(event, ev.eventProperties["RadioChannel"], ev.eventProperties["Callsign"]);
                    } else if (ev.eventType === "Lock") {
                        event.urlToDetail = this.getUrlFromStrings(event.type, ev.isrs);
                        event = this.addRadioChannelFromStrings(event, ev.eventProperties["RadioChannel"], ev.eventProperties["Callsign"]);
                    } else if (ev.eventType && ev.eventType.startsWith("NtsImpact")) {
                        // NtsImpact, NtsImpactStart, NtsImpactEnd
                        event = this.addNtSInformationFromStrings(event, (name: string) => ev.eventProperties[name]);
                    } else if (ev.eventType === "Rdocal") {
                        event = this.addRadioChannelFromStrings(event, ev.eventProperties["Comcha"], null);
                    }
                    events.push(event);
                }
            });
        }

        var routeDirection = new RouteDirectionViewModel();
        if (segment.etd) {
            routeDirection.eta = new Date(segment.etd);
        } else if (segment.eta) {
            routeDirection.eta = new Date(segment.eta);
        }

        routeDirection.maneuverType = segment.maneuverType;
        if (!routeDirection.maneuverType.startsWith("esriDMT") && !routeDirection.maneuverType.startsWith("Charges") && !routeDirection.maneuverType.startsWith('NtsImpact')) {
            routeDirection.maneuverType = "esriDMT" + routeDirection.maneuverType;
        }
        if (routeDirection.maneuverType.startsWith("Charges")) {
            routeDirection.maneuverType = 'ww' + routeDirection.maneuverType;
        }

        // travelled distance from segment length when enabled
        let segmentLengthMsg: string = null;
        if (this.showTravelledDistance) {
            segmentLengthMsg = '<span class="a-icon a-icon-travelled-distance" style="position:relative; top:2px;"></span> ' + kendo.toString(this.travelledDistance / 1000, '#.#') + ' ' + i18n.getMessage('units.kilometers');
            this.travelledDistance += segment.length;
        } else {
            segmentLengthMsg = '<span class="a-icon a-icon-segment-distance" style="position:relative; top:2px;"></span> ' + kendo.toString(segment.length / 1000, '#.#') + ' ' + i18n.getMessage('units.kilometers');
        }
        routeDirection.totalLength = segment.length > 0 ? segmentLengthMsg : '';

        // build segment message with segment attributes
        routeDirection.text = VoyageResultHelper.getSegmentMessage(segment.maneuverType, segment.segmentName, segment.direction, index, segment.segmentProperties);
        routeDirection.events = events;
        routeDirection.compressedGeometry = segment.compressedGeometry;
        routeDirection.countryCodes = segment.countryCodes;
        if (segment.maneuverType.startsWith('NtsImpact')) {
            this.addNtsUrlToSegment(routeDirection, (name: string) => segment.segmentProperties[name]);
        }
        return routeDirection;
    }

    private toViewModels2(route: Itinerary): RouteViewModel {

        let mappedRoute = new RouteViewModel();

        this.travelledDistance = 0;
        mappedRoute.directions = [];
        route.legs.forEach(l => l.segments.forEach((s, index) => {
            mappedRoute.authorities = this.arrayUnique(mappedRoute.authorities.concat(s.authority));
            mappedRoute.directions.push(this.toDirection(s, index));
        }));

        // add departure message
        let departureDirection = new RouteDirectionViewModel();
        let firstLeg = route.legs[0];
        departureDirection.eta = new Date(firstLeg.etd);
        departureDirection.maneuverType = "esriDMTDepart";
        departureDirection.text = VoyageResultHelper.getDepartureOrArrivalMessage(firstLeg.fromObjectName, firstLeg.fromMessage);
        departureDirection.events = [];
        departureDirection.compressedGeometry = firstLeg.segments.length > 0 ? firstLeg.segments[0].compressedGeometry : null;
        mappedRoute.directions.unshift(departureDirection);

        // add arrival message
        let lastLeg = route.legs[route.legs.length - 1];
        let lastSegment = lastLeg.segments[lastLeg.segments.length - 1];
        let arrivalDirection = new RouteDirectionViewModel();
        arrivalDirection.eta = new Date(lastLeg.eta);
        arrivalDirection.maneuverType = "esriDMTStop";
        arrivalDirection.text = VoyageResultHelper.getDepartureOrArrivalMessage(lastLeg.toObjectName, lastLeg.toMessage, false);
        arrivalDirection.events = [];
        arrivalDirection.compressedGeometry = lastSegment?.compressedGeometry;
        mappedRoute.directions.push(arrivalDirection);

        // Traject details
        if (route.allowedDimensions != null) {
            mappedRoute.maxTrajectCEMT = route.allowedDimensions.cemt;
            mappedRoute.maxTrajectDraught = route.allowedDimensions.draught;
            mappedRoute.maxTrajectHeight = route.allowedDimensions.height;
            mappedRoute.maxTrajectLength = route.allowedDimensions.length;
            mappedRoute.maxTrajectWidth = route.allowedDimensions.width;
            mappedRoute.maxTrajectDraughtSource = route.allowedDimensions.draughtSource;
            mappedRoute.maxTrajectHeightSource = route.allowedDimensions.heightSource;
            mappedRoute.maxTrajectLengthSource = route.allowedDimensions.lengthSource;
            mappedRoute.maxTrajectWidthSource = route.allowedDimensions.widthSource;
            mappedRoute.containsTideDep = route.tideDependent;
        }

        mappedRoute.totalTime = Math.ceil(route.totalDuration / 60); // Minutes
        mappedRoute.totalLength = route.totalLength; // Meter
        mappedRoute.totalBridges = 0;
        mappedRoute.totalLocks = route.numberOfLocks;
        return mappedRoute;
    }

    private redrawStops() {
        let isRedrawingStops = true;
        kendo.unbind(this.$stopsContainer.find('ul'));
        this.$stopsContainer.empty();

        // Check if exchange button should be visible
        if (this.viewModel.stops.length > 2) {
            this.$root.find('.exchange-button-container').addClass('hidden');
        } else {
            this.$root.find('.exchange-button-container').removeClass('hidden');
        }

        // Create new <ul>
        const $ul = $('<ul class="list-unstyled"></ul>');
        $ul.appendTo(this.$stopsContainer);

        // Build list
        for (let i = 0; i < this.viewModel.stops.length; i++) {
            const stop = this.viewModel.stops[i];

            // Build the list item html
            const html = this.routePointSelectorTemplate({ stopIndex: i, placeholder: (i === 0) ? i18n.getMessage('directions.from') : i18n.getMessage('directions.to') });
            const $html = $(html);
            const $li = $('<li class="directions-stop-item"></li>');
            $html.appendTo($li);
            $li.appendTo($ul);
            const $inputISRS = $li.find('input.input-isrs');

            // Save stop in data variable (route-point)
            $li.data('route-point', stop);

            $html.find('.btn-select-on-map').attr('title', i18n.getMessage('visuris.directions.selectpointonmap'));
            // Attach click handler for select on map button
            $html.find('.btn-select-on-map').on('click', (e) => {
                this.locateButtonClicked(e, stop);
            });

            // Attach click handler for remove button
            $html.find('.btn-remove-stop').on('click', (e) => {
                this.removeStop(stop);
            });

            // Kendo autocomplete
            // Group by function and order by search priority
            const dsOptions: kendo.data.DataSourceOptions = {
                group: {
                    field: 'functionMessage',
                    dir: 'asc'
                }
            };
            (dsOptions.group as any).compare = (a: any, b: any) => {
                if (a.items.length > 0 && b.items.length > 0) {
                    // always put favorites items on top
                    if (a.items[0].functionMessage === this.favoriteFunctionGroupName) {
                        return -1;
                    }
                    if (b.items[0].functionMessage === this.favoriteFunctionGroupName) {
                        return 1;
                    }
                    // search other according to priority
                    if (a.items[0].searchPriority === b.items[0].searchPriority) {
                        return 0;
                    } else if (a.items[0].searchPriority > b.items[0].searchPriority) {
                        return -1;
                    } else {
                        return 1;
                    }
                }
                return 0;
            }
            const $isrsInput = $html.find('.input-isrs');
            $isrsInput.kendoAutoComplete({
                noDataTemplate: null,
                dataTextField: 'objectName',
                template: this.suggestResultTemplate,
                select: (e) => {
                    const risIndex = e.dataItem;
                    // Set isrs & risIndex to stop object
                    stop.set('isrs', risIndex.isrs);
                    stop.set('risIndex', risIndex);
                    stop.set('location', { x: risIndex.lon, y: risIndex.lat, spatialReference: { wkid: 4326 } });
                    // show favorite btn after location has been selected
                    $html.find('.btn-favorite-location').show();
                    // increment favorite show when it is already favorited
                    if (risIndex.isFavorited) {
                        this.favoriteLocationsRepository.incrementFavoriteLocationScore(risIndex.isrs).catch(e => console.error(e));
                    }
                    this.redrawStops();
                },
                dataSource: createSuggestDataSource(dsOptions, null, this.getLocationSearchRole(i), true),
                height: 400,
                footerTemplate: (e: any) => {
                    const totalItems = e.instance.dataSource.total();
                    const searchFooterDiv = $('<div></div>');
                    let footerText = `${totalItems} ${i18n.getMessage('VisuRIS.Directions.SearchResultsFound')}`;
                    let advancedSearchBtn: JQuery = null;
                    if (totalItems >= 15) {
                        footerText = `${i18n.getMessage('VisuRIS.Directions.TooManySearchResults')} ${footerText}`;
                        advancedSearchBtn = $(`<div><a style="cursor:pointer;">${i18n.getMessage('VisuRIS.Directions.RefineSearchButton')}</a></div>`);
                        advancedSearchBtn.on('click', () => {
                            this.showAdvancedSearchPopup(e.instance.value(), $isrsInput, i);
                        });
                    }
                    searchFooterDiv.append(footerText);
                    if (advancedSearchBtn) searchFooterDiv.append(advancedSearchBtn);
                    return searchFooterDiv;
                },
                clearButton: false
            });
            const stopAutoComplete = $isrsInput.data('kendoAutoComplete');

            // bind click event to open the autocomplete by searching for empty string
            $isrsInput.on('click', async (e: any) => {
                if (e.target.value === '' || e.target.value == null || stop.risIndex == null) {
                    stopAutoComplete.search('');
                } else {
                    stopAutoComplete.search(e.target.value);
                }
            });

            // Bind keyup event to hide isFavorited when text has been edited
            $isrsInput.on('keyup', (e: any) => {
                if (e.target.value === '' || e.target.value == null || (stop.risIndex && stop.risIndex.objectName != e.target.value)) {
                    $html.find('.btn-favorite-location').hide();
                    $html.find('.k-icon.k-i-loading').removeClass('loading-right-to-favorite');
                }
            });

            // Bind change event of stop object
            stop.bind('change', (e: kendo.data.ObservableObjectEvent) => {
                if (e.field === 'risIndex') {
                    if (stop.risIndex) { $inputISRS.val(stop.risIndex.objectName); }
                } else if (e.field === 'location') {
                    if (!isRedrawingStops) {
                        this.drawLocationMarkersOnMap();
                    }
                }
            });

            // Save location as favorite
            $html.find('.btn-favorite-location').on('click', async (e) => {
                const locIsrs = stop.isrs;
                const isFavorited = stop.risIndex.isFavorited;
                try {
                    if (isFavorited) {
                        await this.favoriteLocationsRepository.remove(locIsrs);
                    } else {
                        await this.favoriteLocationsRepository.addFavoriteLocation(locIsrs);
                    }
                    stop.risIndex.isFavorited = !isFavorited;
                    this.redrawStops();
                } catch (e) {
                    if (e.responseJSON) {
                        if (e.responseJSON.exceptionMessage) {
                            alert(i18n.getMessage('general.ApiError', e.responseJSON.exceptionMessage));
                        } else if (e.responseJSON.message) {
                            alert(e.responseJSON.message);
                        }
                    } else {
                        alert(i18n.getMessage('dialog.serviceUnavailable'));
                    }
                }
            });

            // move the kendo loading icon
            if (this.isLoggedIn) {
                const $favBtn = $html.find('.btn-favorite-location');
                if ($favBtn && $favBtn.length > 0 && $favBtn.css('display') !== 'none') {
                    $html.find('.k-icon.k-i-loading').addClass('loading-right-to-favorite');
                } else {
                    $html.find('.k-icon.k-i-loading').removeClass('loading-right-to-favorite');
                }
            }

            // Attach hover handler
            $html.hover((e) => {
                // Mouse enter
                if (this.viewModel.stops.length > 2) {
                    $(e.currentTarget).find('.btn-remove-stop').removeClass('hidden');
                }

                $(e.currentTarget).find('.btn-dragdrop').removeClass('hidden');
            }, (e) => {
                // Mouse leave
                $(e.currentTarget).find('.btn-remove-stop').addClass('hidden');
                $(e.currentTarget).find('.btn-dragdrop').addClass('hidden');
            });

            // Set ObjectName to input box if stop has a risindex
            if (stop.risIndex) { $inputISRS.val(stop.risIndex.objectName); }
        }

        kendo.bind($ul, this.viewModel);

        // Make list items sortable
        $ul.kendoSortable({
            hint: (element: any) => {
                const el = <JQuery>element;
                const originalWidth = el.outerWidth();
                const ret = <JQuery>element.clone().addClass("hint");
                ret.css('min-width', originalWidth.toString() + 'px');
                ret.css('width', originalWidth.toString() + 'px');
                ret.css('max-width', originalWidth.toString() + 'px');
                return ret;
            },
            change: (options) => {
                const s = <IDirectionsStopObservable>options.item.data('route-point');
                this.moveStop(s, options.newIndex);
            },
            ignore: ':not(.draggable)'
        });

        isRedrawingStops = false;
        this.drawLocationMarkersOnMap();
    }

    private locateButtonClicked(event: any, stop: IDirectionsStopObservable) {
        // Listen for click event on map
        this.gisMap.startUsingDirectionWidget();
        // Toggle button for indication dat locator button has been (de)selected 
        const $currentBtn = $(event.currentTarget);
        const locatorIsOn = $currentBtn.hasClass('locator-selected'); // save the current toggle state before turning all off
        // Turn off all toggle buttons first
        this.$root.find('.btn-select-on-map').removeClass('locator-selected');
        this.viewModel.stops.forEach(stop => {
            if (stop.mapClickHandle != null) {
                stop.mapClickHandle.remove();
                stop.mapClickHandle = null;
            }
        })
        // When current button is off -> toggle it on and enable locate
        if (!locatorIsOn) {
            $currentBtn.addClass('locator-selected');
            var that = this;
            stop.mapClickHandle = on(this.map, 'click', (e: any) => {
                this.gisMap.stopUsingDirectionWidget();
                var resolution = that.gisMap._map.getResolution();
                var distance = this.getNearestValueForResolution(resolution);

                const getISRS = this.locator.locationToISRS(e.mapPoint, distance);
                getISRS.then((data) => {
                    if (data && data.isrs) {
                        // Set isrs value for the stop
                        stop.set('isrs', data.isrs);
                        // Retrieve favorite locations 
                        const retrieveFavoriteLocs = this.isLoggedIn ? this.favoriteLocationsRepository.getFavoriteLocations() : Promise.resolve(new FavoriteLocations());
                        // Retrieve RIS Index information
                        const retrieveRisIndex = this.risIndexRepository.get(data.isrs);
                        Promise.all([retrieveFavoriteLocs, retrieveRisIndex]).then(([favoriteLocations, risIndex]) => {
                            if (this.isLoggedIn) {
                                if (favoriteLocations.locations.find(x => x.isrs === risIndex.isrs)) {
                                    stop.set('risIndex', { ...risIndex, isFavorited: true });
                                } else {
                                    stop.set('risIndex', { ...risIndex, isFavorited: false });
                                }
                            } else {
                                stop.set('risIndex', risIndex);
                            }
                            stop.set('location', data.location);
                            // Clear event handle when location selected
                            stop.mapClickHandle.remove();
                            stop.mapClickHandle = null;
                            $currentBtn.removeClass('locator-selected');
                            this.redrawStops();
                        });
                    }
                });
            });
        }
    }

    getNearestValueForResolution(resolution: number): number {
        let nearestKey = -Infinity;
        for (let key in this.resolutionToRadiusMap) {
            const numericKey = parseFloat(key);
            if (numericKey <= resolution && numericKey > nearestKey) {
                nearestKey = numericKey;
            }
        }
        // If the nearest key is still -Infinity, it means the input zoomLevel is lower than all keys.
        // In that case, return 350.
        return nearestKey !== -Infinity ? this.resolutionToRadiusMap[nearestKey] : 350;
    }

    private addStop() {
        var stop = <IDirectionsStopObservable>kendo.observable({ isrs: null, risIndex: null });
        this.viewModel.stops.push(stop);
        // Add intermediate stops just before the last stop, not at the end!
        if (this.viewModel.stops.length > 2) {
            this.moveStop(stop, this.viewModel.stops.length - 2);
        } else {
            this.redrawStops();
        }
    }

    private removeStop(stop?: IDirectionsStopObservable) {
        let indexOfStop = 0;
        if (stop != null) {
            indexOfStop = this.viewModel.stops.indexOf(stop);
            // Remove map click event handler
            if (stop.mapClickHandle != null) {
                stop.mapClickHandle.remove();
            }
        }
        if (indexOfStop >= 0) {
            this.viewModel.stops.splice(indexOfStop, 1); // Remove item from stops in viewmodel
        }
        this.redrawStops();
    }

    private moveStop(stop: IDirectionsStopObservable, newIndex: number) {
        if (newIndex >= 0 && newIndex < this.viewModel.stops.length) {
            const oldIndex = this.viewModel.stops.indexOf(stop);
            this.viewModel.stops.splice(oldIndex, 1); // Remove item at old index
            this.viewModel.stops.splice(newIndex, 0, stop); // Add item at new index
        }
        this.redrawStops();
    }

    private calculateRouteV2(): Promise<RoutingResult> {
        publisher.publish('directions.VoyageCalculationStarted');
        let request = this.getRouteTaskParametersV2();

        var calculateTask: Promise<RoutingResult> = null;
        if (this.mode === 'ROUTE') {
            calculateTask = this.calculator2.calculateRoute(request);
        } else {
            calculateTask = this.calculator2.calculateVoyage(request);
        }

        calculateTask.then((e) => {
            if (e.success) {
                // Checks if dimensions have been reduced and prompt the user to show or discard the result
                if (e.itineraries && e.itineraries.length >= 1
                    && ((e.itineraries[0].allowedDimensions.draught > 0 && e.itineraries[0].allowedDimensions.draught < request.shipDimensions.draught)
                        || (e.itineraries[0].allowedDimensions.height > 0 && e.itineraries[0].allowedDimensions.height < request.shipDimensions.height)
                        || (e.itineraries[0].allowedDimensions.width > 0 && e.itineraries[0].allowedDimensions.width < request.shipDimensions.width)
                        || (e.itineraries[0].allowedDimensions.length > 0 && e.itineraries[0].allowedDimensions.length < request.shipDimensions.length))) {
                    const showResultMessage = i18n.getMessage('VisuRIS.Directions.ReducedDimensionsResult',
                        formatLengthAsMeter(e.itineraries[0].allowedDimensions.length, LengthUnit.Centimeter),
                        formatLengthAsMeter(e.itineraries[0].allowedDimensions.width, LengthUnit.Centimeter),
                        formatLengthAsMeter(e.itineraries[0].allowedDimensions.draught, LengthUnit.Centimeter),
                        formatLengthAsMeter(e.itineraries[0].allowedDimensions.height, LengthUnit.Centimeter));
                    const popupWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) / 4;
                    confirm(showResultMessage, this.options.page.name, { width: popupWidth, draggable: true }).then(x => {
                        this.setCurrentRouteV2(e.itineraries);
                        publisher.publish('directions.VoyageCalculationCompleted', e.itineraries[0], request, this.viewModel.hull);
                    });
                } else {
                    this.setCurrentRouteV2(e.itineraries);
                    publisher.publish('directions.VoyageCalculationCompleted', e.itineraries[0], request, this.viewModel.hull);
                }
            } else {
                // Builds translated error message based on error reason and tags
                let objectName = null;
                if (e.errorTags && e.errorTags['ISRS']) {
                    const nodeNotFoundRisIndex = this.viewModel.stops.find(x => x.isrs === e.errorTags['ISRS'])?.risIndex;
                    if (nodeNotFoundRisIndex) {
                        objectName = nodeNotFoundRisIndex.nationalObjectName ?? nodeNotFoundRisIndex.objectName;
                    }
                }
                const errorMessage = VoyageResultHelper.getErrorMessageFromReasonAndTags(e.errorReason, e.errorTags, objectName);
                const popupWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) / 4;
                alert(errorMessage,
                    this.mode === 'ROUTE' ? i18n.getMessage('VisuRIS.Directions.RouteCalculationFailedTitle') : i18n.getMessage('VisuRIS.Directions.VoyageCalculationFailedTitle'),
                    { width: popupWidth, draggable: true });
                console.error(e.errorMessage);
            }
        }, (error) => {
            console.error(error);
        });
        return calculateTask;
    }

    private getRouteTaskParameters(): ICalculateRouteOptions {
        // stops = ; seperated isrs codes
        var stops = '';
        for (let i = 0; i < this.viewModel.stops.length; i++) {
            var isrs = this.viewModel.stops[i].get('isrs');
            stops += isrs + ";";
        }
        stops = stops.substr(0, stops.length - 1); // Remove last ;

        var params: ICalculateRouteOptions = { stops: stops };

        //var startDateTime = '';
        //var endDateTime = '';

        // Check if a date time was selected
        if (this.viewModel.dateTimeMode === 'arrive') {
            params.endTime = this.viewModel.arriveDepartAt;
            //startDateTime = this.viewModel.arriveDepartAt.getTime().toString();
        } else {
            params.departureTime = this.viewModel.arriveDepartAt;
            //endDateTime = this.viewModel.arriveDepartAt.getTime().toString();
        }

        params.shipLength = (this.viewModel.shipLength != null ? (this.viewModel.shipLength * 100) : 0).toString();
        params.shipWidth = (this.viewModel.shipWidth != null ? (this.viewModel.shipWidth * 100) : 0).toString();
        params.shipDraught = (this.viewModel.shipDraught != null ? (this.viewModel.shipDraught * 100) : 0).toString();
        params.shipHeight = (this.viewModel.shipHeight != null ? (this.viewModel.shipHeight * 100) : 0).toString();
        params.shipSpeed = (this.viewModel.shipSpeed != null ? this.viewModel.shipSpeed : 0).toString();
        params.shipTonnage = (this.viewModel.shipTonnage != null ? this.viewModel.shipTonnage : 0).toString();
        params.recreationalBoating = this.viewModel.pleziervaart;
        params.professionalShipping = this.viewModel.beroepsvaart;
        params.passengerShip = this.viewModel.passagiersvaart;
        params.loaded = this.viewModel.loaded;
        params.adn = this.viewModel.adn;
        params.convoy = this.viewModel.convoy;
        params.pusher = this.viewModel.pusher;
        params.avoidTideDep = this.viewModel.avoidTide;
        //params.outputLines = this.viewModel.outputLines;        
        //params.directionsLanguage = 'nl';
        //params.directionsLengthUnits = this.viewModel.lengthUnits;
        //params.fixedRoute = this.viewModel.fixedRoute;
        params.usePassageDurations = this.viewModel.usePassageDurations;
        params.computationType = this.mode === 'ROUTE' ? null : 3;
        return params;
    }

    // set X in 321X0 (load / empty / adn)
    private loadTypeDigit(): number {
        if (this.viewModel.adn) {
            return 30;
        }
        if (this.viewModel.loaded) {
            return 10;
        }
        return 20;
    }

    // get shipCategory as defined in Comex
    private getShipCategory(): number {
        if (this.viewModel.pleziervaart) {
            return 20000;
        }
        if (this.viewModel.passagiersvaart) {
            return 31000;
        }
        if (this.viewModel.beroepsvaart) {
            if (this.viewModel.convoy || this.viewModel.pusher) {
                return 32200 + this.loadTypeDigit();
            }
            return 32100 + this.loadTypeDigit();
        }
        return null;
    }

    private getRouteTaskParametersV2(): RouteCalculatorRequest {
        let request = new RouteCalculatorRequest();

        let nStops = this.viewModel.stops.length;
        request.startISRS = this.viewModel.stops[0].get('isrs');
        request.endISRS = this.viewModel.stops[nStops - 1].get('isrs');
        request.viaPoints = [];

        for (let i = 1; i < this.viewModel.stops.length - 1; i++) {
            let via = new Via();
            via.isrs = this.viewModel.stops[i].get('isrs');
            request.viaPoints.push(via);
        }

        // Check if a date time was selected
        if (this.viewModel.dateTimeMode === 'arrive') {
            request.arriveBy = this.viewModel.arriveDepartAt;
        } else {
            request.departAt = this.viewModel.arriveDepartAt;
        }

        request.shipDimensions = new Dimensions();
        request.shipDimensions.length = (this.viewModel.shipLength != null ? (this.viewModel.shipLength * 100) : 0);
        request.shipDimensions.width = (this.viewModel.shipWidth != null ? (this.viewModel.shipWidth * 100) : 0);
        request.shipDimensions.draught = (this.viewModel.shipDraught != null ? (this.viewModel.shipDraught * 100) : 0);
        request.shipDimensions.height = (this.viewModel.shipHeight != null ? (this.viewModel.shipHeight * 100) : 0);
        request.shipSpeed = (this.viewModel.shipSpeed != null ? this.viewModel.shipSpeed : 0);
        request.shipCategory = this.getShipCategory();

        request.resultFormatting = new ResultFormatting();
        var lang = page.getCurrentLanguage();
        if (lang) {
            request.resultFormatting.resultLanguage = lang.code;
        }
        request.resultFormatting.timezoneOffset = new Date().getTimezoneOffset();

        request.calculationOptions = new CalculationOptions();
        request.calculationOptions.usePassageDuration = this.viewModel.usePassageDurations;
        request.calculationOptions.useSailingSpeeds = this.viewModel.useSailingSpeeds;
        request.calculationOptions.useReducedDimensions = this.viewModel.useReducedDimensions;
        request.calculationOptions.useSmartReducedDimensions = this.viewModel.useSmartReducedDimensions;
        request.calculationOptions.computationType = this.mode === 'ROUTE' ? 'SHORTEST' : 'BOTH'
        return request;
    }

    private updateMoreOptionsFromHash() {
        let _shiplength, _shipWidth, _shipDraught, _shipHeight, _shipSpeed, _shipTonnage, _departDateTime, _targetGroupCode, _mode, _shipName;

        if ((_shipHeight = this.getValueFromHash("height")) != null) {
            this.viewModel.shipHeight = Number(_shipHeight);
        }
        if ((_shiplength = this.getValueFromHash("length")) != null) {
            this.viewModel.shipLength = Number(_shiplength);
        }
        if ((_shipWidth = this.getValueFromHash("width")) != null) {
            this.viewModel.shipWidth = Number(_shipWidth);
        }
        if ((_shipDraught = this.getValueFromHash("draught")) != null) {
            this.viewModel.shipDraught = Number(_shipDraught);
        }
        if ((_shipSpeed = this.getValueFromHash("speed")) != null) {
            this.viewModel.shipSpeed = Number(_shipSpeed);
        }
        if ((_shipTonnage = this.getValueFromHash("tonnage")) != null) {
            this.viewModel.shipTonnage = Number(_shipTonnage);
        }
        if ((_targetGroupCode = this.getValueFromHash("targetGroupCode")) != null) {
            _targetGroupCode = _targetGroupCode.toUpperCase();
            // type based on nts types (ex.: COM = commercial, PLE = pleasurecraft, ... )
            if (_targetGroupCode === 'PLE') {
                // pleasure
                this.changeBeroepsvaartOption(false);
            } else {
                // commercial = default
                this.changeBeroepsvaartOption(true);
            }
        }
        // voyage route switch
        if ((_mode = this.getValueFromHash('mode')) != null && _mode.toUpperCase() === 'ROUTE') {
            this.mode = 'ROUTE';
            this.toggleVoyageRouteMode();
        } else {
            if ((_departDateTime = this.getValueFromHash("etd")) != null) {
                this.viewModel.dateTimeMode = 'depart';
                this.viewModel.arriveDepartAt = new Date(_departDateTime);
                this.viewModel.arriveDepartAtMessage = this.viewModel.arriveDepartAt.toLocaleString([], { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' });
            }
        }
        // ship name
        if ((_shipName = this.getValueFromHash('shipName')) != null) {
            this.$root.find('input.vessel-select').data('kendoDropDownList').text(_shipName);
            this.viewModel.shipName = _shipName;
        }
        // ship options
        if (this.getValueFromHash('recreational') === '1') {
            this.changeBeroepsvaartOption(false);
        } else if (this.getValueFromHash('passenger') === '1') {
            this.changeBeroepsvaartOption(true);
            this.viewModel.passagiersvaart = true;
        } else if (this.getValueFromHash('loaded') === '1' || this.getValueFromHash('adn') === '1' || this.getValueFromHash('convoy') === '1' || this.getValueFromHash('commercial') === '1') {
            this.changeBeroepsvaartOption(true);
            if (this.getValueFromHash('loaded') === '1') {
                this.viewModel.loaded = true;
                if (this.getValueFromHash('adn') === '1') {
                    this.viewModel.adn = true;
                }
            }
            if (this.getValueFromHash('convoy') === '1') {
                this.viewModel.convoy = true;
                this.viewModel.pusher = true;
            }
        }
        this.viewModel.shipOptionMessage = this.getShipOptionMessage();
        this.viewModel.shipIconElement = this.getShipIcon();

        // advanced options
        if (this.getValueFromHash("useSailingSpeeds") === '1') {
            this.viewModel.useSailingSpeeds = true;
        }
        if (this.getValueFromHash("useReducedDimensions") === '1') {
            this.viewModel.useReducedDimensions = true;
        }
        if (this.getValueFromHash("usePassageDurations") === '1') {
            this.viewModel.usePassageDurations = true;
        }
    }


    private updateStopsFromHash() {
        return new Promise<void>((resolve, reject) => {
            try {
                this.ignoreStopsChange = true;

                var hashStops = this.getValueFromHash("stops");
                if (hashStops != null && hashStops.length >= 2) {
                    var hashIsrs = hashStops.split(',');
                    var stopsToAdd = hashIsrs.length - this.viewModel.stops.length;
                    if (stopsToAdd > 0) {
                        for (let i = 0; i < stopsToAdd; i++) {
                            this.addStop();
                        }
                    } else if (stopsToAdd < 0) {
                        var stopsToRemove = stopsToAdd * -1;
                        for (let i = 0; i < stopsToRemove; i++) {
                            this.removeStop();
                        }
                    }
                    // check if location has been favorited if logged in
                    if (this.isLoggedIn) {
                        const retrieveFavoriteLocs = this.favoriteLocationsRepository.getFavoriteLocations();
                        retrieveFavoriteLocs.then((locs) => {
                            const retrieveRisIndices = this.createRetrieveRisIndicesPromises(hashIsrs, locs.locations);
                            Promise.all(retrieveRisIndices).then(() => {
                                resolve();
                            });
                        }, (error) => {
                            reject();
                        });
                    } else {
                        const retrieveRisIndices = this.createRetrieveRisIndicesPromises(hashIsrs);
                        Promise.all(retrieveRisIndices).then(() => {
                            resolve();
                        });
                    }
                } else {
                    resolve();
                }
            } catch (e) {
                reject();
            } finally {
                this.ignoreStopsChange = false;
            }
        });
    }

    private createRetrieveRisIndicesPromises(isrsArray: string[], favoriteLocations: LocationData[] = []): Promise<any>[] {
        const retrieveRisIndices: Promise<any>[] = [];
        // Cannot just create empty array, as we may lose the fact that this.viewModel.stops should be an array of IDirectionsStopObservable
        // the splice option below is a fast and reliable way to ensure the stops array is empty.
        this.viewModel.stops.splice(0, this.viewModel.stops.length);

        for (const isrs of isrsArray) {
            if (isrs && isrs !== '') {
                const stop = (kendo.observable({ isrs: null, risIndex: null })) as IDirectionsStopObservable;
                stop.set('isrs', isrs);
                this.viewModel.stops.push(stop);

                // Retrieve RIS Index information
                const retrieveRisIndex = this.risIndexRepository.get(isrs);
                retrieveRisIndex.then((risIndex) => {
                    if (favoriteLocations.find(x => x.isrs === risIndex.isrs)) {
                        stop.set('risIndex', { ...risIndex, isFavorited: true });
                    } else {
                        stop.set('risIndex', { ...risIndex, isFavorited: false });
                    }
                    stop.set('location', { x: risIndex.lon, y: risIndex.lat, spatialReference: { wkid: 4326 } });
                }, (error) => {
                    console.error(error);
                });
                retrieveRisIndices.push(retrieveRisIndex);
            } else {
                const stop = (kendo.observable({ isrs: null, risIndex: null })) as IDirectionsStopObservable;
                this.viewModel.stops.push(stop);
            }
        }
        return retrieveRisIndices;
    }

    private updateHash() {
        var currentStops = this.getValueFromHash('stops');
        var newStops = this.getUrlEncodedStops();

        if (newStops !== currentStops) {
            this.updateKeyValueInHash('stops', newStops);
        }
    }

    private getUrlEncodedStops(): string {
        var stops = '';
        for (let i = 0; i < this.viewModel.stops.length; i++) {
            if (i > 0) { stops += ','; }
            if (this.viewModel.stops[i].isrs != null) {
                stops += this.viewModel.stops[i].isrs;
            }

        }
        return stops;
    }

    private getUrlEncodedStopsSettings(): string {
        return 'stops=' + this.getUrlEncodedStops();
    }

    private getUrlEncodedMoreOptionsSettings(): string {
        let str = 'moreOptions=1';
        if (this.viewModel.shipHeight) {
            str += '&height=' + this.viewModel.shipHeight;
        }
        if (this.viewModel.shipLength) {
            str += '&length=' + this.viewModel.shipLength;
        }
        if (this.viewModel.shipWidth) {
            str += '&width=' + this.viewModel.shipWidth;
        }
        if (this.viewModel.shipDraught) {
            str += '&draught=' + this.viewModel.shipDraught;
        }
        if (this.viewModel.shipSpeed) {
            str += '&speed=' + this.viewModel.shipSpeed;
        }
        if (this.viewModel.shipTonnage) {
            str += '&tonnage=' + this.viewModel.shipTonnage;
        }
        if (this.mode === 'ROUTE') {
            str += '&mode=' + this.mode;
        } else if (this.viewModel.arriveDepartAtMessage !== this.leaveNowMessage) {
            str += '&etd=' + this.viewModel.arriveDepartAt.toISOString();
        }
        if (this.viewModel.shipName) {
            str += '&shipName=' + this.viewModel.shipName;
        }
        if (this.viewModel.pleziervaart) {
            str += '&recreational=1';
        } else if (this.viewModel.passagiersvaart) {
            str += '&passenger=1';
        } else if (this.viewModel.loaded || this.viewModel.adn || this.viewModel.convoy) {
            if (this.viewModel.loaded) {
                str += '&loaded=1';
            }
            if (this.viewModel.adn) {
                str += '&adn=1';
            }
            if (this.viewModel.convoy) {
                str += '&convoy=1';
            }
        } else if (this.viewModel.beroepsvaart) {
            str += '&commercial=1';
        }
        if (this.viewModel.useReducedDimensions) {
            str += '&useReducedDimensions=1';
        }
        if (this.viewModel.useSailingSpeeds) {
            str += '&useSailingSpeeds=1';
        }
        if (this.viewModel.usePassageDurations) {
            str += '&usePassageDurations=1';
        }
        return str;
    }

    /**
     * Update a search term in hash
     * @param term
     */
    private updateKeyValueInHash(key: string, value: string) {
        if (window.location.hash != null && window.location.hash !== '') {
            var hashParams = (<any>$).deparam(window.location.hash.substring(1));
            hashParams[key] = value;
            window.location.hash = '#' + $.param(hashParams);
        }
    }

    /**
     * Get a search term from hash
     */
    private getValueFromHash(key: string): string {
        if (window.location.hash != null && window.location.hash !== '') {
            var urlParams = (<any>$).deparam(window.location.hash.substring(1));
            if (urlParams[key] != null) {
                return decodeURIComponent(urlParams[key]);
            }
        }
        return null;
    }

    private arrayUnique(array: any) {
        var a = array.concat();
        for (var i = 0; i < a.length; ++i) {
            for (var j = i + 1; j < a.length; ++j) {
                if (a[i] === a[j])
                    a.splice(j--, 1);
            }
        }

        return a;
    }

    private getCorrectShipType(selected: any): string {
        switch (page.getCurrentLanguage().code) {
            case 'nl':
                return selected.shiptype_nl;
            case 'en':
                return selected.shiptype_en;
            case 'fr':
                return selected.shiptype_fr;
            case 'de':
                return selected.shiptype_de;
            case 'bg':
                return selected.shiptype_bg;
            case 'cs':
                return selected.shiptype_cs;
            case 'hr':
                return selected.shiptype_hr;
            case 'hu':
                return selected.shiptype_hu;
            case 'ro':
                return selected.shiptype_ro;
            case 'sk':
                return selected.shiptype_sk;
            case 'sr':
                return selected.shiptype_sr;
            default:
                return '';
        }
    }

    private async showAdvancedSearchPopup(searchText: string, $locationInput: JQuery, stopIndex: number) {
        const locationSearchRole: LocationSearchRole = this.getLocationSearchRole(stopIndex);
        const title = this.getLocationSearchPopupTitle(stopIndex);
        let advancedSearchUrl = await new WebpageRepository().getWebpageURL(Constants.PageReferences.ADVANCED_LOCATION_SEARCH_PAGE);
        advancedSearchUrl = url.updateUrlParameter(advancedSearchUrl, 'searchRole', locationSearchRole.toString());
        advancedSearchUrl = url.updateUrlParameter(advancedSearchUrl, 'searchText', searchText);
        import('CMS/Popup').then(Popup => {
            Popup.show({
                title: title,
                url: advancedSearchUrl,
                close: (risIndex: any) => {
                    if (risIndex.isrs) {
                        const stop = this.viewModel.stops[stopIndex];
                        // Set isrs & risIndex to stop object
                        stop.set('isrs', risIndex.isrs);
                        stop.set('risIndex', risIndex);
                        stop.set('location', { x: risIndex.lon, y: risIndex.lat, spatialReference: { wkid: 4326 } });
                        $locationInput.val(risIndex.objectName);
                        this.redrawStops();
                    }
                },
                minWidth: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) / 2,
                minHeight: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0) * 0.7
            });
        });
    }

    private getLocationSearchRole(index: number): LocationSearchRole {
        let locationSearchRole: LocationSearchRole = null;
        if (index === 0) {
            locationSearchRole = LocationSearchRole.Departure;
        } else if (index === this.viewModel.stops.length - 1) {
            locationSearchRole = LocationSearchRole.Destination;
        } else {
            locationSearchRole = LocationSearchRole.ViaPoint;
        }
        return locationSearchRole;
    }

    private getLocationSearchPopupTitle(index: number): string {
        let title = '';
        if (index === 0) {
            title = i18n.getMessage('advancedLocationSearch.searchDeparture');
        } else if (index === this.viewModel.stops.length - 1) {
            title = i18n.getMessage('advancedLocationSearch.searchDestination');
        } else {
            title = i18n.getMessage('advancedLocationSearch.searchViaPoint');
        }
        return title;
    }

    private getFavoriteVoyageName(): string {
        let name = this.viewModel.shipName;
        if (name == null || name == '') {
            name = `${this.viewModel.shipLength} x ${this.viewModel.shipWidth}`;
        }
        const departure = this.viewModel.stops[0].risIndex.objectName;
        const destination = this.viewModel.stops[this.viewModel.stops.length - 1].risIndex.objectName;
        return `${name} - ${departure} -> ${destination}`;
    }

    private getFavoriteVoyageDto(name: string, id: string = null): FavoriteVoyage {
        const favoriteVoyage: FavoriteVoyage = {
            id: id,
            stops: this.viewModel.stops.map(x => { return { isrs: x.isrs, name: x.risIndex.objectName }; }),
            favoriteVoyageName: name,
            shipLength: this.viewModel.shipLength,
            shipWidth: this.viewModel.shipWidth,
            shipDraught: this.viewModel.shipDraught,
            shipHeight: this.viewModel.shipHeight,
            shipSpeed: this.viewModel.shipSpeed,
            shipTonnage: this.viewModel.shipTonnage,
            recreationalBoating: this.viewModel.pleziervaart,
            professionalShipping: this.viewModel.beroepsvaart,
            passengerShip: this.viewModel.passagiersvaart,
            loaded: this.viewModel.loaded,
            adn: this.viewModel.adn,
            convoy: this.viewModel.convoy,
            pusher: this.viewModel.pusher
        };
        return favoriteVoyage;
    }

    private updateModelFromFavoriteVoyageDto(favoriteVoyage: FavoriteVoyage): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.viewModel.adn = favoriteVoyage.adn;
            this.viewModel.convoy = favoriteVoyage.convoy;
            this.viewModel.loaded = favoriteVoyage.loaded;
            this.viewModel.passagiersvaart = favoriteVoyage.passengerShip;
            this.viewModel.beroepsvaart = favoriteVoyage.professionalShipping;
            this.viewModel.pusher = favoriteVoyage.pusher;
            this.viewModel.pleziervaart = favoriteVoyage.recreationalBoating;
            this.viewModel.shipDraught = favoriteVoyage.shipDraught;
            this.viewModel.shipHeight = favoriteVoyage.shipHeight;
            this.viewModel.shipLength = favoriteVoyage.shipLength;
            this.viewModel.shipSpeed = favoriteVoyage.shipSpeed;
            this.viewModel.shipTonnage = favoriteVoyage.shipTonnage;
            this.viewModel.shipWidth = favoriteVoyage.shipWidth;
            // ship name from part of favorite voyage name
            const shipName = favoriteVoyage.favoriteVoyageName.split('-')[0];
            if (shipName.indexOf('x') >= 0) {
                // dont put the dimension as ship name -> reset the shipname
                this.$root.find('input.vessel-select').data('kendoDropDownList').text(i18n.getMessage('VisuRIS.Directions.VesselSelectChange'));
            } else {
                this.$root.find('input.vessel-select').data('kendoDropDownList').text(shipName);
                this.viewModel.shipName = shipName;
            }
            // ship options messages
            this.viewModel.shipOptionMessage = this.getShipOptionMessage();
            this.viewModel.shipIconElement = this.getShipIcon();
            // fill in the stops (risindex, location and isrs) + mark the locations favorited where needed
            const retrieveFavoriteLocs = this.favoriteLocationsRepository.getFavoriteLocations();
            retrieveFavoriteLocs.then((locs) => {
                const stopIsrs = favoriteVoyage.stops.map(x => x.isrs);
                const retrieveRisIndices = this.createRetrieveRisIndicesPromises(stopIsrs, locs.locations);
                Promise.all(retrieveRisIndices).then(() => {
                    resolve();
                });
            }, (error) => {
                reject();
            });
        });
    }

    private buildNumericTextBox(dimensionSuffix: string, settings: kendo.ui.NumericTextBoxOptions) {
        const inputCssClass = `.input-ship-${dimensionSuffix}`;
        const textCssClass = `.text-ship-${dimensionSuffix}`;
        const outerSpanCssClass = `.ship-${dimensionSuffix}`;
        const unitCssClass = `.ship-${dimensionSuffix} .unit-align`;
        const kendoInputCssClass = `.k-numerictextbox.input-ship-${dimensionSuffix}`;
        const input = this.$root.find(inputCssClass).kendoNumericTextBox(settings).data('kendoNumericTextBox');
        this.$root.find(kendoInputCssClass).addClass('hidden');
        this.$root.find(outerSpanCssClass).on('click focusin', textCssClass, e => {
            this.$root.find(kendoInputCssClass).removeClass('hidden');
            this.$root.find(unitCssClass).removeClass('hidden');
            this.$root.find(textCssClass).addClass('hidden');
            input.focus();
        });
        this.$root.find(outerSpanCssClass).on('focusout', `:not(${textCssClass})`, e => {
            this.$root.find(kendoInputCssClass).addClass('hidden');
            this.$root.find(unitCssClass).addClass('hidden');
            this.$root.find(textCssClass).removeClass('hidden');
        });
        this.$root.find(kendoInputCssClass).on('keyup', e => {
            if (e.key === 'Enter') {
                $(e.currentTarget).trigger('focusout');
                // use class tabable to get all dimension inputs in order to go next
                const $allDimensionInputs = this.$root.find(':not(".hidden") > .tabable:not([style*="display: none;"])');
                const indexOfCurrent = $allDimensionInputs.index($allDimensionInputs.filter(outerSpanCssClass));
                if (indexOfCurrent < $allDimensionInputs.length - 1) {
                    $($allDimensionInputs[indexOfCurrent + 1]).find('.ship-dimension-text').trigger('focus');
                } else {
                    this.$stopsContainer.find('input.input-isrs').first().trigger('focus');
                }
            }
        })
    }

    public destroy() { }

}